module.exports = {
	"en": {
		"moet-core": {
			"select_language": {
				"title": "Select your language",
				"paragraph": "This will be your default language.",
				"submit": "OK"
			},
			"products": {
				"mandatory": "Always included",
				"kco": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Offer all of our payment methods."
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Pay now"
							},
							"description": {
								"default": "Offer instant payments by card or bank transfer."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "Pay in 30 days"
							},
							"description": {
								"default": "Offer 30 days to pay. No interest."
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Financing"
							},
							"description": {
								"default": "Offer to pay over 6-36 months.",
								"DE": "Offer to pay over 6-24 months",
								"AT": "Offer to pay over 6-24 months."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "Instalments"
							},
							"description": {
								"default": "Offer 3 interest-free installments.",
								"GB": "Offer 3 interest-free instalments."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "Installments",
								"AU": "Pay in 4"
							},
							"description": {
								"default": "Offer 4 interest-free installments.",
								"GB": "Offer 4 interest-free instalments."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Payment methods"
					},
					"description": {
						"default": "Pick up from our standalone payment solutions. Choose one, or combine several. Simple, one-time integration, no matter what you choose."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Pay now"
							},
							"description": {
								"default": "Offer instant payments by card or bank transfer."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "Pay in 30 days"
							},
							"description": {
								"default": "Offer 30 days to pay. No interest."
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Financing"
							},
							"description": {
								"default": "Offer to pay over 6-36 months.",
								"DE": "Offer to pay over 6-24 months",
								"AT": "Offer to pay over 6-24 months."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "Instalments"
							},
							"description": {
								"default": "Offer 3 interest-free installments.",
								"GB": "Offer 3 interest-free instalments."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "4 Payments",
								"CA": "4 Payments",
								"AU": "Pay in 4"
							},
							"description": {
								"default": "Offer 4 interest-free installments.",
								"GB": "Offer 4 interest-free instalments.",
								"US": "Orders from $35 to $1000 can be split into 4 interest-free payments, due every 2 weeks.",
								"CA": "Orders from $35 to $1000 can be split into 4 interest-free payments, due every 2 weeks."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Replace your store's checkout with Klarna complete checkout services."
					},
					"description_expanded": {
						"default": "Replace your store's checkout with Klarna complete checkout services."
					}
				},
				"kp_one": {
					"name": {
						"default": "Payment Method"
					},
					"description": {
						"default": "Add Klarna payment methods to your existing checkout"
					},
					"description_expanded": {
						"default": "Offering Klarna payment methods leads to an average increase of 30% in conversion, 41% in AOV and 36% in purchase frequency."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "This field is required to proceed",
					"generic": "The provided value is invalid",
					"required_suffix": "is required to proceed",
					"generic_suffix": "is invalid",
					"min_one": "You must select at least one element",
					"min": "You must select at least {min} elements",
					"max": "You can't select more than {max} elements",
					"given_name": "First name missing",
					"family_name": {
						"general": "Last name missing",
						"too_short": "Please provide a valid surname"
					},
					"date_of_birth": {
						"general": {
							"default": "Please provide a valid date of birth (DD/MM/YYYY)",
							"US": "Please provide a valid date of birth (MM/DD/YYYY)"
						},
						"too_young": "All stakeholders need to be older then 16 years",
						"too_young_eighteen": "You must be older than 18 years"
					},
					"street_address": "Please provide an address",
					"street_address2": "Please provide a valid address line 2",
					"postal_code": "Please provide a postal code",
					"country": "Please provide a country",
					"region": "Please provide a region",
					"state": "Please provide a state",
					"iban": "Please provide a account number (IBAN)",
					"companyName": "Please provide a company name",
					"email": "Please provide a valid email",
					"contact_email": "Please provide a valid contact email",
					"support_email": "Please provide a valid customer support email",
					"support_phone": "Please provide a valid support phone number",
					"selling_countries": "You must select at least one country",
					"store_category": "You need to select one of the options",
					"name": "Please provide a store name",
					"legal_form": "Please choose one of the listed business types",
					"generic_toggle_undefined": "Please select one of the options",
					"website": "Please provide a valid website url",
					"bankAccounts": "Please provide at least one bank account",
					"product": "Please select a product",
					"platform": "Please select a platform",
					"password": "Please create a strong password",
					"currency_code": "Please provide a currency code",
					"account_holder": "Please provide a bank account holder",
					"account_type": "Please provide a bank account type",
					"routing_number": "Please provide a valid routing number",
					"account_number": {
						"first": "Please provide a valid account number for the default bank account",
						"second": "Please provide a valid account number for the first additional bank account",
						"third": "Please provide a valid account number for the second additional bank account",
						"fourth": "Please provide a valid account number for the third additional bank account",
						"general": "Please provide a valid account number"
					},
					"role": "Please provide a role",
					"address": "Please provide an address",
					"political_exposed_person": "Please provide a PEP information",
					"pep_position": "Please provide a position information",
					"pep_relationship": "Please provide a relationship information to the PEP person",
					"goodsCategory": "Please provide a goods category",
					"registered": "Please provide information about your business registration",
					"subjectToVat": "Please provide a VAT number",
					"registrationCourt": "Please provide a registration court",
					"registrationId": {
						"general": {
							"default": "Enter a valid registration number",
							"AT": "Enter a valid registration number",
							"AU": "Enter a valid ACN",
							"ES": "Enter a valid company NIF/NIE/DNI",
							"GB": "Enter a valid organization number",
							"GR": "Enter a valid G.E.MI. number (Γ.Ε.ΜΗ.)",
							"CA": "Enter a valid business number",
							"NZ": "Please enter a valid business number",
							"US": "Enter a valid Employer Identification Number"
						},
						"missing_leading_0_GB": "Please provide an 8 digit organization number. Your organization number might be missing an initial 0 (e.g. 03452678)",
						"invalid": {
							"default": "Please enter a valid registration number",
							"AT": "Registration number should be 5 to 11 characters long. Please note this is not your VAT nor your Merchant ID.",
							"AU": "ACN should be 9 digits long, no space allowed. Eg: 123456789",
							"BE": "Registration number should be 10 digits long. Eg: 1234567890",
							"CA": "Business number should be 9 digits long. Eg: 123456789",
							"CZ": "Registration number should be 8 digits long. Eg: 12345678",
							"DE": "Registration number should be 6 to 11 characters long and must start with HRA, HRB, GnR, VR or PR followed by a space. Please note this is not your VAT nor your Merchant ID.",
							"ES": "NIF/NIE/DNI should be 8 or 9 characters long starting with 1 letter/digit followed by 6 or 7 digits and 1 letter/digit",
							"FI": "Registration number should be 8 digits long with a dash before the last one, no space allowed. Eg: 1234567-8",
							"FR": "Registration number should be 9 digits long, e.g 123 456 789 or 123456789 (SIREN), or 14 digits long, e.g. 123 456 789 12345 or 12345678912345 (SIRET).",
							"IE": "Registration number should be 2 letters followed by 6 digits or only 6 digits if you are a sole trader (e.g. AB123456).",
							"IT": "Registration number should be 11 digits (e.g. 01234567890) or a combination of 16 numbers and capital letters (e.g. ABCABC12A12A123A)",
							"GB": "Organization number should be 8 digits long. Eg: 12345678, or two letters followed by 6 digits (SC123456), or 1 letter followed by 7 digits (S1234567)",
							"GR": "G.E.MI. number should be 12 digits long, e.g 012345678901",
							"NL": "Registration number should be 8 digits long. Eg: 12345678",
							"NO": "Registration number should be 9 digits long, no space allowed. Eg: 123456789",
							"NZ": "Business number should be 13 digits long. Eg: 1234567890123",
							"PL": "Registration number should be 10 digits long, no space allowed. Eg: 1234561234",
							"PT": "Registration number should be 9 digits long, no space allowed. Eg: 123123123",
							"SE": "Registration number should be 10 digits long with a dash, no space allowed. Eg: 123456-1234",
							"US": "Employer Identification Number should be 9 digits long with a \"-\" after the first two. Eg: 12-3456789",
							"MX": "RFC should be 12 characters long, starting with the company initials, the 6 digit incorporation date and the check value. Eg: ABC921010H20"
						}
					},
					"tocLink": "Something went wrong with the terms and conditions. Please try again later or contact our customer support at {supportEmail}",
					"vat": {
						"general": {
							"default": "Enter a valid VAT number",
							"AU": "Enter a valid ABN",
							"ES": "Please enter a valid company NIF/NIE/DNI",
							"NZ": "Enter a valid GST number"
						},
						"invalid": {
							"default": "Invalid VAT number",
							"AT": "VAT number should be ATU followed by 8 digits. Eg: ATU12345678",
							"AU": "ABN should be 11 digits long.",
							"CZ": "VAT number should be CZ followed by 8, 9 or 10 digits. Eg: CZ123456789",
							"GR": "VAT number should be 9 digits long and must start with EL. Eg: EL123456789",
							"DE": "VAT number should be DE followed by 9 digits. Eg: DE123456789",
							"ES": "NIF/NIE/DNI should be 8 or 9 characters long starting with 1 letter/digit followed by 6 or 7 digits and 1 letter/digit",
							"FR": "VAT number should be FR followed by 2 letters/digits and 9 digits (SIREN), e.g FRXX123456789",
							"GB": "VAT number should be 6 to 15 characters long.",
							"IE": "VAT number should be IE followed by 8 or 9 characters which includes 1 or 2 letters. Eg: IE1234567WA, IE1234567A",
							"IT": "VAT number should be IT followed by 11 digits. Eg: IT12345678912",
							"NL": "VAT number should be NL followed by 9 digits, followed by B and 2 digits. Eg: NL123456789B12",
							"NZ": "GST number should be 8 digits long (12345678) or 9 digits long, with or without hyphens every 3 digits (123-123-123 or 123123123)",
							"PL": "VAT number should be PL followed by 10 digits. Eg: PL1234567890",
							"PT": "VAT number should be PT followed by 9 digits. Eg: PT123123123",
							"MX": "RFC should start with the company initials, the 6 digit incorporation date and the check value. Eg: ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Please provide the last 4 digits of your SSN",
							"format": "Please enter the last 4 digits of your SSN"
						},
						"US_FULL_SSN": {
							"general": "Please provide the full (9 digits) SSN",
							"format": "Please enter the full (9 digits) your SSN"
						},
						"CA": {
							"general": "Please provide valid a SIN or a Passport Number",
							"format": "SIN: XXX-XXX-XXX / Passport Number: ABXXXXXX"
						},
						"SE": {
							"general": "Please enter a valid Personal Identification Number (PNO)",
							"format": "Please enter PNO in format: YYYYMMDD-XXXX"
						},
						"FI": {
							"general": "Please enter a valid Personal Identification Code (HETU)",
							"format": "Please enter HETU in format: DDMMYYSXXXX"
						},
						"NO": {
							"general": "Please provide a valid National Identity Number",
							"format": "Please enter in format: DDMMYYXXXXX"
						},
						"DK": {
							"general": "Please enter a valid Personal Identification Number (CPR)",
							"format": "Please enter CPR in format: DDMMYY-XXXX"
						},
						"IT": {
							"general": "Please enter a valid Fiscal Code",
							"format": "Please enter Fiscal Code in format: CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Please enter a valid Personal Identification Number (DNI or NIE)",
							"format": "Please enter the DNI or NIE, e.g. 12345678A"
						},
						"PL": {
							"general": "Please enter a valid Personal Identification Code (PESEL)",
							"format": "Please enter PESEL in format: YYMMDDZZZXQ"
						},
						"default": {
							"general": "Please provide a valid passport number"
						}
					},
					"store_name": "Please provide a store name"
				},
				"errors_keys": {
					"correlationIdLabel": "Correlation ID: {correlationId}",
					"decisionTaken": "Pre-assesssment decision already taken. Please reload the page.",
					"maintenanceMode": "Our app is currently down for maintenance. Please, check back again later",
					"validation": {
						"storeName": {
							"invalidType": "Please provide a valid store name."
						},
						"email": {
							"invalidType": "Please provide a valid email."
						},
						"goodsCategory": {
							"invalidType": "Please provide a goods category."
						},
						"website": {
							"invalidType": "Please provide a valid website."
						}
					}
				}
			},
			"general": {
				"yes": "Yes",
				"no": "No",
				"encrypted_text": "*******",
				"pricing_link_eu": "View all prices per country",
				"pricing_link_us": "View prices",
				"formFieldOptional": "optional",
				"buttons": {
					"next": "Next",
					"back": "Back",
					"continue": "Continue",
					"submit_application": {
						"default": "Get started",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Get Started"
					},
					"add_aditional_item": "+ Add additional item"
				},
				"unknown_step_title": "Please provide required information",
				"selected": "Selected",
				"clear_all": "Clear all"
			},
			"errors": {
				"general": "An error has occurred. Please contact our support.",
				"salesforce": "Please try refreshing the page. If the error still persists please send the error ID to the #smooothforce-support slack channel and we will help you out.",
				"managed_kyc": "Please try refreshing the page. If the error still persists please contact our merchant support or your sales contact.",
				"copy": "Copy",
				"noTermsAccepted": "Please read and accept all our listed agreements",
				"termsAlreadyAccepted": "You already accepted all the listed agreements",
				"mandatoryField": " is required"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Sole trader",
					"PARTNERSHIP": "Partnership",
					"PUBLIC_LISTED_COMPANY": "Public listed company",
					"PRIVATE_COMPANY": "Private company"
				},
				"organization_entity_types": {
					"C_CORP": "C corporation",
					"S_CORP": "S corporation",
					"PARTNERSHIP": "Partnership",
					"TRUST_ESTATE": "Trust/estate",
					"INDIVIDUAL": "Individual",
					"SOLE_PROPRIETORSHIP": "Sole proprietorship",
					"SOLE_TRADER": "Sole trader",
					"LIMITED_LIABILITY_COMPANY": "Limited liability company",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Single member LLC"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Clothing & Shoes - Adult shoes and clothing",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Automotive Products - Automotive parts and accessories",
					"BAGS_AND_WALLETS": "Jewelry & Accessories - Bags and wallets",
					"BODY_AND_HAIR_CARE": "Health & Beauty - Body and hair care",
					"BOOK_AND_MAGAZINES": "Entertainment - Book and magazines",
					"CANDY": "Food & Beverage - Candy",
					"CAR_ELECTRONICS": "Electronics - Car electronics",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Children Products - Children clothes and nurturing products",
					"CHILDREN_TOYS": "Children Products - Children toys",
					"CLEANING_AND_SANITARY": "Home & Garden - Cleaning and sanitary",
					"COLLECTIBLES": "Leisure, Sport & Hobby - Collectibles",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Leisure, Sport & Hobby - Concept stores and miscellaneous",
					"COSMETICS": "Health & Beauty - Cosmetics",
					"COSTUMES_AND_PARTY_SUPPLIES": "Leisure, Sport & Hobby - Costumes and party supplies",
					"DATING_SERVICES": "Intangible products - Dating services",
					"DECORATION_AND_ART": "Home & Garden - Decoration and art",
					"DIETARY_SUPPLEMENTS": "Health & Beauty - Dietary supplements",
					"DIGITAL_SERVICES": "Intangible products - Digital services",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Children Products - Diversified children products",
					"DIVERSIFIED_ELECTRONICS": "Electronics - Diversified electronics",
					"DIVERSIFIED_ENTERTAINMENT": "Entertainment - Diversified entertainment",
					"DIVERSIFIED_EROTIC_MATERIAL": "Erotic Materials - Diversified erotic material",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Health & Beauty - Diversified health and beauty products",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Home & Garden - Diversified home and garden products",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Jewelry & Accessories - Diversified jewelry and accessories",
					"EDUCATION": "Intangible products - Education",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Electronics - Electronic equipment and related accessories",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Erotic Materials - Erotic clothing and accessories",
					"EVENT_TICKETS": "Intangible products - Event tickets",
					"FOOD_AND_BEVERAGE": "Food & Beverage - Food and beverage",
					"FRAGRANCES": "Health & Beauty - Fragrances",
					"FURNITURE": "Home & Garden - Furniture",
					"GENERAL_SHOES_AND_CLOTHING": "Clothing & Shoes - General shoes and clothing",
					"HOBBY_ARTICLES": "Leisure, Sport & Hobby - Hobby articles",
					"HOUSEHOLD_ELECTRONICS": "Electronics - Household electronics",
					"JEWELRY_AND_WATCHES": "Jewelry & Accessories - Jewelry and watches",
					"KITCHENWARE": "Home & Garden - Kitchenware",
					"MARKETPLACES": "Intangible products - Marketplaces",
					"MUSIC_AND_MOVIES": "Entertainment - Music and movies",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Leisure, Sport & Hobby - Musical instruments and equipment",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Jewelry & Accessories - Non prescription sunglasses and lenses",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Electronics - Office machines and related accessories",
					"OTHER_SERVICES": "Intangible products - Other services",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Health & Beauty - Personal care and body improvement",
					"PET_SUPPLIES": "Home & Garden - Pet supplies",
					"PHARMACEUTICAL_PRODUCTS": "Health & Beauty - Pharmaceutical products",
					"PLANTS_AND_FLOWERS": "Home & Garden - Plants and flowers",
					"PRESCRIPTION_OPTICS": "Health & Beauty - Prescription optics",
					"PRINTS_AND_PHOTOS": "Leisure, Sport & Hobby - Prints and photos",
					"SAFETY_PRODUCTS": "Home & Garden - Safety products",
					"SEX_TOYS": "Erotic Materials - Sex toys",
					"SPORTS_GEAR_AND_OUTDOOR": "Leisure, Sport & Hobby - Sports gear and outdoor",
					"TOBACCO": "Food & Beverage - Tobacco",
					"TOOLS_AND_HOME_IMPROVEMENT": "Home & Garden - Tools and home improvement",
					"TRAVEL_SERVICES": "Intangible products - Travel services",
					"UNDERWEAR": "Clothing & Shoes - Underwear",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Entertainment - Video games and related accessories",
					"WHEELS_AND_TIRES": "Automotive Products - Wheels and tires",
					"WINE_BEER_AND_LIQUOR": "Food & Beverage - Wine beer and liquor",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Clothing & Shoes - Youthful shoes and clothing",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Age restricted - Gambling, Betting, Casinos & Lottery",
					"CHARITIES_AND_NGO": "Intangible products - Charities and NGO services",
					"EROTIC_SERVICES": "Erotic Materials - Erotic services",
					"FINANCIAL_SERVICES_CRYPTO": "Financial services - Crypto-related activities",
					"FINANCIAL_SERVICES_MSB": "Financial services - Money Service Business",
					"FINANCIAL_SERVICES_E_WALLETS": "Financial services - E-wallets",
					"FINANCIAL_SERVICES_TRADING": "Financial services - Trading",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Intangible products - Social platform communities",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Travel - Air Travel & Cruise Operators",
					"TRAVEL_BROKER_AND_AGENCIES": "Travel - Broker & Agencies",
					"TRAVEL_GROUND_TRANSPORTATION": "Travel - Ground Transportation",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Travel - Accommodation & Resorts",
					"EVENT_ORGANIZER": "Event - Organizer",
					"EVENT_BROKER_AND_AGENCIES": "Event - Broker & Agencies"
				},
				"us_states": {
					"AL": "Alabama",
					"AK": "Alaska",
					"AZ": "Arizona",
					"AR": "Arkansas",
					"CA": "California",
					"CO": "Colorado",
					"CT": "Connecticut",
					"DC": "District of Columbia",
					"DE": "Delaware",
					"FL": "Florida",
					"GA": "Georgia",
					"HI": "Hawaii",
					"ID": "Idaho",
					"IL": "Illinois",
					"IN": "Indiana",
					"IA": "Iowa",
					"KS": "Kansas",
					"KY": "Kentucky",
					"LA": "Louisiana",
					"ME": "Maine",
					"MD": "Maryland",
					"MA": "Massachusetts",
					"MI": "Michigan",
					"MN": "Minnesota",
					"MS": "Mississippi",
					"MO": "Missouri",
					"MT": "Montana",
					"NE": "Nebraska",
					"NV": "Nevada",
					"NH": "New Hampshire",
					"NJ": "New Jersey",
					"NM": "New Mexico",
					"NY": "New York",
					"NC": "North Carolina",
					"ND": "North Dakota",
					"OH": "Ohio",
					"OK": "Oklahoma",
					"OR": "Oregon",
					"PA": "Pennsylvania",
					"RI": "Rhode Island",
					"SC": "South Carolina",
					"SD": "South Dakota",
					"TN": "Tennessee",
					"TX": "Texas",
					"UT": "Utah",
					"VT": "Vermont",
					"VA": "Virginia",
					"WA": "Washington",
					"WV": "West Virginia",
					"WI": "Wisconsin",
					"WY": "Wyoming"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Person",
						"COMPANY": "Company"
					},
					"roles": {
						"OWNER": "Owner",
						"ULTIMATE_BENEFICIAL_OWNER": "Ultimate Beneficial Owner",
						"CONTROL_OVER_MANAGEMENT": "Control over management",
						"APPLICANT": "Authorized Signatory",
						"SOLE_TRADER": "Sole Trader",
						"PARTNER": "Partner"
					}
				},
				"payment_intervals": {
					"DAILY": "Daily",
					"WEEKLY": "Weekly"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Traditional sale of goods",
						"description": "Merchant is selling products or services in a traditional way: the goods are considered fully consumed when first delivered and typically there is no extended period between order and delivery"
					},
					"VOUCHER": {
						"label": "Voucher",
						"description": "More than 10% of sales consists of vouchers and / or gift cards"
					},
					"MEMBERSHIP": {
						"label": "Membership",
						"description": "More than 10% of sales consists of memberships"
					},
					"SUBSCRIPTION": {
						"label": "Subscription",
						"description": "More than 10% of sales consists of subscriptions"
					},
					"PHARMACIES": {
						"label": "Pharmacies",
						"description": "Merchant sells prescription or non prescription based drugs"
					},
					"US_PHARMACIES": {
						"label": "US Pharmacies",
						"description": "Merchant sells prescription or non prescription based drugs in US"
					},
					"MEDICAL_SERVICES": {
						"label": "Medical Services",
						"description": "Merchant sells medical services such as testing, examination, nursing care"
					},
					"MARKETPLACES": {
						"label": "Marketplaces",
						"description": "Merchant has a sub-merchant relation"
					},
					"FIREARM_DEALERS": {
						"label": "Firearm Dealers",
						"description": "Merchant sells weapon, ammunition requiring license"
					},
					"AUCTIONS": {
						"label": "Auctions",
						"description": "Merchant is an auction house"
					},
					"ALCOHOL": {
						"label": "Alcohol",
						"description": "Merchant sells alcohol"
					},
					"TOBACCO": {
						"label": "Tobacco",
						"description": "Merchant sells tobacco including or excluding nicotine or merchant sells e-cigarettes"
					},
					"HEMP_CBD_THC": {
						"label": "Hemp, CBD, or THC",
						"description": "Merchant sells products containing Hemp, CBD or THC"
					},
					"DONATIONS_CHARITY": {
						"label": "Donations and Charity",
						"description": "Merchant is a donation or charity organisation that onboards with “Post Settlement Disbursement\""
					},
					"TRAVEL": {
						"label": "Travel",
						"description": "More than 10% of sales consists of travel"
					},
					"EVENTS": {
						"label": "Events",
						"description": "More than 10% of sales consists of events"
					},
					"COURSES": {
						"label": "Courses",
						"description": "More than 10% of sales consists of courses"
					},
					"EDUCATIONAL_COURSES": {
						"label": "Educational Courses",
						"description": "The merchant sells educational courses lasting for a specific period of time."
					},
					"FOOD_DELIVERY": {
						"label": "Food delivery",
						"description": "The merchant provides a food delivery service."
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "Customised pre-order/Furniture",
						"description": "The merchant sells pre-order products, such as furniture."
					},
					"DIGITAL_CONTENT": {
						"label": "Digital content",
						"description": "The merchant sells digital content, such as e-books and online games."
					},
					"GAMING_INDUSTRY": {
						"label": "Gaming industry (Gambling, Betting, Casinos,  Lottery)",
						"description": "The merchant provides services related to the gaming industry, such as gambling, betting, casinos, and lotteries."
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Hello, {firstName}",
						"primary_title_without_name": "Hello,",
						"sub_title": "More Klarna is more Klarna, Shakespeare said.",
						"sub_title_no_products": "Start you Klarna experience by picking a product below",
						"sub_title_kp_products": "Select another Klarna product",
						"sub_title_ongoing_product": "Continue the setup of {productName}"
					},
					"sidebar_left": {
						"products": {
							"title": "Payment products",
							"text_blocks": [
								{
									"text": "Add a solution to your setup"
								}
							]
						}
					},
					"buttons": {
						"start": "Start",
						"continue": "Continue",
						"view_summary": "View Summary",
						"add_another_product": "Add another product"
					},
					"goodie_bags": {
						"playground": {
							"title": "Playground",
							"text": "Switch to the Playground Environment to explore and generate Test API credentials so you can test your platform.",
							"link": "Playground"
						},
						"marketing_assets": {
							"title": "Marketing assets",
							"text": "Using Klarna means smoooth sailing for your customers. Use our marketing assets to get them excited about it.",
							"link": "Get assets"
						},
						"your_application": {
							"title": "Your application",
							"text": "Click here to complete your setup or view your application details, including Terms & Conditions.",
							"link": "Open"
						},
						"invite_more_users": {
							"title": "Invite more users",
							"text": "Invite your collaborators to the Merchant Portal, you will be able to set custom permissions for each of them!",
							"link": "Invite users"
						}
					},
					"footer": {
						"title": "Always included with Klarna",
						"list": {
							"merchant_portal": {
								"title": "The Merchant Portal",
								"text_blocks": [
									{
										"text": "Manage everything Klarna with full access to the backend."
									}
								]
							},
							"global_products": {
								"title": "Global products, local faces",
								"text_blocks": [
									{
										"text": "All our products are built to meet local preferences and legislation."
									}
								]
							},
							"local_support": {
								"title": "Local support for you and your customers",
								"text_blocks": [
									{
										"text": "We have thousands of people ready to help your customers when they need the human touch."
									}
								]
							},
							"marketing_tool": {
								"title": "Klarna as a marketing tool",
								"text_blocks": [
									{
										"text": "We’ll give you access to Klarna materials you can use in your marketing initiatives."
									}
								]
							},
							"single_integration": {
								"title": "Single integration, automatic updates",
								"text_blocks": [
									{
										"text": "One integration, no updates. Ever."
									},
									{
										"text": "Once you’ve integrated Klarna, that’s it. It’s always updated - and you don’t need to lift a finger."
									}
								]
							},
							"no_risk": {
								"title": "No risk for you or your customers",
								"text_blocks": [
									{
										"text": "Your payouts are always guaranteed, and your customers are covered by Klarna Buyer Protection."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Klarna API Credentials",
							"text_blocks": [
								{
									"text": "Klarna API credentials connect our product to your store so you can start selling."
								}
							]
						},
						"toc_key": {
							"title": "Terms & Conditions",
							"text_blocks": [
								{
									"text": "You need to update your e-commerce Terms & Conditions"
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Integration instructions",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "How to use Klarna API credentials",
							"ordered_list": {
								"one": "Generate and download your credentials",
								"two": "Paste the credentials (Klarna API username and password) into your platform as explained in the integration instructions below"
							}
						},
						"number_of_live_keys_in_total": {
							"title": "5 Klarna API credentials in total",
							"text": "You can generate up to five Klarna API credentials. Get the first one here, then create the rest in Settings.",
							"button": "Generate Klarna API Credentials"
						},
						"how_to_update_toc": {
							"title": "How to update T&C",
							"ordered_list": {
								"one": "Visit the link",
								"two": "Read the instructions and copy the text",
								"three": "Include it in the Terms & Conditions of your webstore"
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "Please remember to update the text with the products you signed up for.",
							"linkText": "Go to update Terms & Conditions >"
						},
						"buttons": {
							"back": "Back"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "Your application is being reviewed…",
						"TRANSACTION_DETAILS_STARTED": "Your application is being reviewed by our team. We will get back to you as soon as possible.",
						"TRANSACTIONS_REVIEW_MANUAL": "Your application is being reviewed by our team. We will get back to you as soon as possible.",
						"TRANSACTIONS_ENABLED": "Congratulations. You are ready to sell with Klarna.",
						"PAYOUTS_REVIEW_AUTOMATED": "Your request for payouts is being reviewed…",
						"PAYOUTS_REVIEW_MANUAL": "Your request for payouts is being reviewed by our team. We will get back to you as soon as possible.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "Waiting for your first sale with Klarna...",
						"TRANSACTIONS_DISABLED": "Your account is disabled until you complete the enable payouts step.",
						"SUSPENDED": "Your account is suspended.",
						"notice": "We currently have longer than average waiting times to review your application. Don’t worry, your application is being reviewed and we’ll reach out with more information about the next steps. We appreciate your patience and thank you for your understanding."
					},
					"statuses": {
						"pending": "Pending",
						"done": "Done"
					},
					"in_review": {
						"title": "We’re reviewing your application.",
						"subtitle": "We’re currently doing a final review of your application with Klarna to make sure that everything in the contract looks correct. This is a manual process, so the handling times may vary, but we’ll get it done as fast as possible.",
						"content": {
							"title": "To ensure that the review is done as quick as possible, make sure the following is visible on your website:",
							"list": {
								"default": {
									"item_1": "Your registered company name",
									"item_2": "Your registered company number",
									"item_3": "Your registered company address",
									"item_4": "Return policy of at least 14 days",
									"item_5": "Customer service email or number"
								},
								"US": {
									"item_1": "Registered company name",
									"item_2": "Return policy",
									"irem_3": "Customer service email or number"
								},
								"AU": {
									"item_1": "ABN (Company number) or Registered Business Name.",
									"item_3": "Your registered company address",
									"item_4": "Return policy of at least 14 days",
									"item_5": "Customer service email or number"
								}
							}
						},
						"footer": "We’ll send you an email once the review is complete or if we need any additional information from you."
					},
					"suspended": {
						"title": "Unfortunately…",
						"subtitle": "After reviewing your contract details, we had to reject your application. There can be several reasons why your application was not approved. Below are some of the most common overall factors:",
						"content": {
							"title": "",
							"list": {
								"item_1": "Your store does not comply with the ethical guidelines of Klarna.",
								"item_2": "The contact person submitted is unreachable.",
								"item_3": "Other technical or administrative factors."
							}
						},
						"footer": "Thank your for your interest in Klarna. Please contact us if you have any questions regarding or if you’d like to sign up  with a different store in the future."
					},
					"disabled": {
						"title": "Your application has been disabled.",
						"subtitle": "Your account was automatically disabled because it’s missing legally required information.",
						"content": {
							"title": "This usually happens when Klarna has asked you to provide some information and you didn’t answer before the specified due date."
						},
						"footer": "If you believe this is a mistake or would like to resubmit the information, please reach out to Merchant Support using the contact information in the footer of this page."
					},
					"ready_to_connect": {
						"title": "Connect your store",
						"subtitle": "Your contract is completed and you can now integrate Klarna in your store. Follow the steps below to complete the integration.",
						"status_messsage": {
							"title": "Integration not yet completed",
							"subtitle": "Follow the integration instructions to connect your store. This status will turn green once a transaction has been made using Klarna."
						},
						"content": {
							"title": "Instructions",
							"options": {
								"label_1": "Generate and save your Klarna API credentials",
								"description_1": "Generate new API credentials and download them to your computer. You'll need these API credentials in the next section.",
								"label_2": "Install Klarna in your Shopify store"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "Almost there",
						"subtitle": "You are one step closer to offering smoooth shopping experience to your customers! Your contract is completed and your store is ready for integration.",
						"buttons": {
							"connect": "Connect your store"
						},
						"additional_info": "Please notice that the integration will only be marked as fully complete when we receive the first purchase, which might take a while depending on your platform."
					},
					"store_connected": {
						"title": "Your store is connected",
						"subtitle": "Your store integration to Klarna is complete and your customers are able to pay using Klarna.",
						"status_messsage": {
							"title": "Integration sucessful",
							"subtitle": "A Klarna transaction has been successfully processed through your store.",
							"button_text": {
								"shown": "Show integration instructions",
								"hidden": "Hide integration instructions"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "Your application",
							"subtitle": "Review your application information.",
							"button_text": "View summary"
						},
						"connect_store": {
							"title": "Klarna API credentials",
							"subtitle": "Generate your Klarna API credentials to integrate your store.",
							"button_text": "Generate Klarna API credentials"
						},
						"add_product": {
							"title": "Products",
							"subtitle": "Click here if you want to add a product for this setup.",
							"button_text": "Add products"
						}
					},
					"timeline": {
						"application": {
							"title": "Your application",
							"alert": {
								"view_summary": "View summary",
								"rejected": "We had to reject your application.",
								"review": "Review your application information by clicking the link below."
							}
						},
						"payouts": {
							"title": "Payouts enabled"
						},
						"integration": {
							"title": "Integration not yet completed",
							"alert": "Follow the integration instructions to connect your store."
						},
						"integration_complete": {
							"title": "Integration completed!"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "Congratulations your setup is complete!",
						"rejection": "Sorry, we could not complete your setup."
					},
					"header_new": {
						"title": "Welcome, Klarna Merchant",
						"subtitle": "Summary",
						"rejection": "Application rejected"
					},
					"joy_section": {
						"approved": {
							"title": "Approved!",
							"content": "Your application has been reviewed and approved. Full access to Klarna's service is now at your fingertips. We're excited to get to work with you!",
							"button_title": "Check your orders",
							"link": "or our marketing assets"
						},
						"rejected": {
							"title": "Unfortunately...",
							"content_1": "After reviewing your application, we are not able approve your merchant contract.",
							"content_2": "Feel free to contact our support team if you have any questions."
						}
					},
					"sidebar_left": {
						"application_details": "Your application details",
						"store_details": {
							"title": "Store details",
							"text_blocks": [
								{
									"text": "A summary of your details"
								}
							]
						},
						"credentials": {
							"title": "Klarna API credentials",
							"text_blocks": [
								{
									"text": "Your Klarna API credentials"
								}
							]
						},
						"payouts": {
							"title": "Payouts",
							"text_blocks": [
								{
									"text": "Your submitted bank details"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Additional bank accounts",
							"text_block": null
						},
						"business_owners": {
							"title": "Business owners",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Material influencers",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Stakeholders",
							"text_blocks": [
								{
									"text": "Your submitted information"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Business owners",
								"no_elements": "You did not submit any business owners"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Default bank account",
								"no_elements": "No default bank account available"
							},
							"additional_bank_accounts": {
								"title": "Additional bank accounts",
								"no_elements": "You did not submit any additional bank accounts"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Owners",
								"no_elements": "You did not submit any owners"
							},
							"ultimate_beneficial_owner": {
								"title": "Beneficial Owners",
								"no_elements": "You did not submit any beneficial owners"
							},
							"applicant": {
								"title": "Applicants",
								"no_elements": "You did not submit any applicants"
							},
							"control_over_management": {
								"title": "Persons with control over management",
								"no_elements": "You did not submit any control over management stakeholders"
							}
						},
						"buttons": {
							"back": "Back",
							"next_step": "Next"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "We already have your data",
							"text_blocks": [
								{
									"text": "This is the information you have previously given us."
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "You did not submit any business owners"
						},
						"buttons": {
							"submit": "Submit",
							"back": "Back"
						}
					}
				},
				"checking_page": {
					"title": "Checking...",
					"subtitle": "Thanks for submitting the application. Please wait while we're checking it..."
				},
				"success_page": {
					"title": "You can now connect your store",
					"subtitle": "Thank you for submitting the application.",
					"buttons": {
						"next": "Next"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "Basics",
						"business": "Business",
						"stakeholders": "Stakeholders",
						"bank_accounts": "Bank Accounts"
					}
				},
				"app_error": {
					"title": "The Products app is currently unavailable",
					"message": "We are experiencing problems with our application and are already looking into it. We try to resolve problems as soon as possible. Please try again later."
				},
				"temporarily_down": {
					"title": "We are experiencing technical difficulties",
					"message": "We apologize for any inconvenience and assure you that we are doing our best to resolve the issue. Please, check back again later."
				},
				"maintenance_mode": {
					"title": {
						"products_app": "Our Products App is currently down for Maintenance",
						"signup_app": "Our Signup App is currently down for Maintenance"
					},
					"message": "We are working to improve your experience and hope to be done as soon as possible. Please, check back again later."
				},
				"unknown_merchant": {
					"before_link": "If you already have an agreement with us, please visit",
					"link_text": "this page",
					"after_link": "to find out more about our products!"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "An error has occurred.",
						"invalid_token": "This link has expired"
					},
					"message": {
						"invalid_token_risk": " Please contact #smooothforce-support slack channel and we will help you out.",
						"invalid_token": "Please get in touch with your sales contact.",
						"invalid_flow_type": "This merchant's onboarding type and status are incompatible. If you believe it is an error, please reach Merchant Support."
					}
				},
				"topbar": {
					"title": "Setup",
					"widget_type": {
						"MANAGED_KYC": "KYC collection",
						"MANAGED_RISK": "Pre-assessment collection",
						"MANAGED_SME_RISK": "SME Pre-assessment collection"
					}
				},
				"product_card": {
					"incompatible_description": "Not available for your country/platform",
					"kco_footer_text": "The payment methods available in Klarna Checkout depend on your country of registration and the country that you sell to.",
					"products_link_text": "More"
				},
				"product_prices_card": {
					"title": "Products",
					"subtitle": "{country}",
					"pricing": "Pricing for {country}",
					"monthly_fee": "monthly fee",
					"transaction_fee": "transaction fee",
					"before_link": "I agree to Klarna",
					"link_text": "Terms & Conditions",
					"after_link_one_product": "for this product",
					"after_link_more_than_one_product": "for these products",
					"product_not_available_in_your_country": "* This product is not available for your home market, but it will work in other countries.",
					"edit_link": "Edit",
					"merchant_agreement": {
						"before_link": "I agree to the",
						"link_text": "Merchant Agreement",
						"after_link_one_product": "for this product",
						"after_link_more_than_one_product": "for these products"
					},
					"pricing_annex": {
						"before_link": "I agree to the",
						"link_text": "Pricing Terms",
						"after_link_one_product": "for this product"
					}
				},
				"support_footer": {
					"text": "Support in English",
					"copyright": {
						"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). All rights reserved.",
						"ap": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579.",
						"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Terms & Conditions.",
					"privacy_policy": "Privacy Policy",
					"merchant_id": "Merchant ID {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Merchant Support",
					"recaptcha": {
						"1_main_text": "This site is protected by reCAPTCHA and the Google",
						"2_privacy_policy": "Privacy Policy",
						"3_and": "and",
						"4_terms_of_service": "Terms of Service",
						"5_apply": "apply."
					}
				},
				"global_prices_dialog": {
					"title_eu": "Prices for all our markets",
					"title_us": "Prices",
					"subtitle": "You are only charged a fee per transaction, that's smoooth!",
					"table": {
						"country": "Country",
						"price_column_heading": "Fee per transaction",
						"global": "Global",
						"title": {
							"kp": "Payment methods",
							"kco": "Klarna Checkout",
							"kco_one": "Klarna Checkout",
							"kp_one": "Klarna Payment Method"
						},
						"headers": {
							"kp_one": "Service Charge"
						}
					},
					"buttons": {
						"back": "Back"
					},
					"foot_notes": {
						"global_price": "* Local currency of merchant, otherwise "
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "First transaction",
						"content": "Before we can review your payout details we need a first order. Don't want to waste your own money? No problem!",
						"button": "Fake it!"
					},
					"transactions": {
						"title": "Approve transactions",
						"content": "You can just fake the salesforce transaction approval",
						"button": "Approve"
					},
					"payouts": {
						"title": "Approve payouts",
						"content": "You can just fake the salesforce payouts approval",
						"button": "Approve"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Default bank account",
						"additional": "Additional bank account {index}",
						"normal": "Bank account {index}"
					},
					"currency_code": {
						"label": "Currency"
					},
					"country_of_bank_account": {
						"label": "Country"
					},
					"account_number": {
						"label": {
							"default": "Account number",
							"MX_LOCAL": "CLABE number"
						}
					},
					"account_holder": {
						"label": "Account holder name"
					},
					"routing_number": {
						"label": "Routing number"
					},
					"transit_number": {
						"label": "Transit number"
					},
					"institution_number": {
						"label": "Institution number"
					},
					"bic": {
						"label": {
							"default": "BIC",
							"AU": "BSB"
						}
					},
					"no_edit_button": "You can edit bank account information after completing your onboarding"
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Legal name of the company"
					},
					"country": {
						"label": "Country"
					},
					"registrationId": {
						"label": {
							"default": "Registration Number",
							"AT": "Registration Number",
							"AU": "ACN",
							"CA": "Business Number",
							"ES": "Company NIF/NIE/DNI",
							"GB": "Organization Number",
							"GR": "G.E.MI. number (Γ.Ε.ΜΗ.)",
							"US": "Employer Identification Number"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Registration Court"
					},
					"goodsCategory": {
						"label": "Goods Category"
					},
					"registered": {
						"label": {
							"default": "Registered Company",
							"AU": "Company has an ACN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "Company Subject to VAT",
							"AU": "Company Subject to ABN",
							"ES": "Company has a NIF/NIE/DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "VAT Number",
							"AU": "ABN",
							"ES": "Company NIF/NIE/DNI"
						}
					},
					"storeName": {
						"label": "Store Name"
					},
					"website": {
						"label": "Website"
					},
					"email": {
						"label": "Customer support email"
					},
					"entityType": {
						"label": "Entity type"
					},
					"toc_data": {
						"label": "Terms and Conditions",
						"toc_approval_text": {
							"before_link": "Your",
							"link_text": "terms & conditions",
							"after_link": "accepted on {date}",
							"merchant_agreement": {
								"before_link": "Your",
								"link_text": "Merchant Agreement",
								"after_link": "accepted on {date}"
							},
							"pricing_annex": {
								"before_link": "Your",
								"link_text": "Pricing Annex",
								"after_link": "accepted on {date}"
							}
						}
					},
					"companyName": {
						"label": "Partnership Name"
					},
					"registeredCompanyName": {
						"label": "Company Name"
					},
					"address": {
						"label": "Address"
					},
					"operatingAddress": {
						"label": "Operating Address"
					},
					"organizationEntityType": {
						"label": "Tax classification"
					}
				},
				"api_key_dialog": {
					"title": "Klarna API credentials generated",
					"subtitle": "The credentials will be shown only one time. Click the button below to download your credentials before closing this window.",
					"key_box": {
						"username": {
							"label": "Klarna API username"
						},
						"password": {
							"label": "Klarna API password"
						},
						"file_name": "Klarna_credentials"
					},
					"buttons": {
						"download": "Download as .txt"
					}
				},
				"platform_instructions": {
					"step": "Step {current}/{max}",
					"next": "Next",
					"back": "Back",
					"shopify": [
						{
							"title": "Generate and save your Klarna API credentials",
							"step_instructions": [
								[
									{
										"text": "Generate new API credentials and download the file to your computer. Open the file and keep it open, as you'll need these API credentials in the next section."
									}
								]
							],
							"alternate": [
								{
									"text": "For more detailed information about your Shopify integration, follow the"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "extended integration guide."
								}
							]
						},
						{
							"title": "Install Klarna in your Shopify store",
							"step_instructions": [
								[
									{
										"text": "Head to the"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Klarna Payment Method Shopify setup wizard."
									}
								],
								[
									{
										"text": "Follow the instructions there to complete your integration."
									}
								]
							],
							"alternate": [
								{
									"text": "For more detailed information about your Shopify integration, follow the"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "extended integration guide."
								}
							]
						},
						{
							"title": "Place a trial purchase",
							"step_instructions": [
								[
									{
										"text": "In order to verify that the integration is set up correctly, please place a trial purchase on your store."
									}
								],
								[
									{
										"text": "After placing the order, go to"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Orders in Merchant Portal,"
									},
									{
										"text": "find your order and cancel it, to avoid paying for it yourself."
									}
								],
								[
									{
										"text": "Once your integration is successful, the banner at the top of this page will turn green and show the words \"Integration Completed\"."
									}
								]
							],
							"alternate": [
								{
									"text": "For more detailed information about your Shopify integration, follow the"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "extended integration guide."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Enable the Klarna Payment Method plugin for Plentymarkets",
							"step_instructions": [
								[
									{
										"text": "To be able to install the Klarna plugin, you need a running system of Plentymarkets CERES. The"
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "Ceres Plugin"
									},
									{
										"text": "is available for download on plentyMarketplace. From there, you are also redirected to the"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "installation instructions."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For detailed information concerning Klarna integration with Plentymarkets Ceres please follow"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "this link."
									}
								]
							]
						},
						{
							"title": "Installation & Setup",
							"step_instructions": [
								[
									{
										"text": "The installation of the Klarna Plugin is done via the"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplace."
									},
									{
										"text": "You are also redirected to the plentyMarketplace from the backend of the plentymarkets system. An"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "instruction how to install plugins in plentymarkets"
									},
									{
										"text": "can be found on plentyKnowledge."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For detailed information concerning Klarna integration with Plentymarkets Ceres please follow"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "this link."
									}
								]
							]
						},
						{
							"title": "Plugin Configuration",
							"step_instructions": [
								[
									{
										"text": "The plugin is configured directly in the respective set. By clicking on the line of the"
									},
									{
										"bold": "Klarna plugin"
									},
									{
										"text": "the configuration page opens."
									}
								],
								[
									{
										"text": "The configuration is divided into two areas:"
									},
									{
										"list": [
											[
												{
													"bold": "Authentication:"
												},
												{
													"text": "The mode is used to determine whether it is testing or productive. Depending on the mode, the user name and password must be stored."
												}
											],
											[
												{
													"bold": "General Settings:"
												},
												{
													"text": "Here you select the product you want  to use. Either Klarna's individual payment methods (Klarna Payment) or Klarna's entire checkout (Klarna Checkout). When selecting the checkout, the checkout in the shop will then be automatically overwritten by Klarna Checkout."
												}
											]
										]
									},
									{
										"text": "There are no further settings necessary and if you deactivate the plugin this will be undone."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For detailed information concerning Klarna integration with Plentymarkets Ceres please follow"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "this link."
									}
								]
							]
						},
						{
							"title": "Final information",
							"step_instructions": [
								[
									{
										"text": "The following system requirements apply:"
									},
									{
										"list": [
											{
												"text": "Plentymarkets version 7"
											},
											{
												"text": "Ceres and IO Plugins installed"
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For detailed information concerning Klarna integration with Plentymarkets Ceres please follow"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "this link."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "Enable the Klarna Checkout plugin for WooCommerce",
							"step_instructions": [
								[
									{
										"text": "First off, make sure you’ve installed the Klarna Checkout plugin for WooCommerce. If you don’t have the plugin yet, head to"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "this page"
									},
									{
										"text": "to get it."
									}
								],
								[
									{
										"text": "Once you have your Klarna API credentials, go to “Settings” and then “Checkout” in your WooCommerce panel. Choose Klarna Checkout."
									}
								],
								[
									{
										"text": "Enable Klarna Checkout by checking the checkbox Enable Klarna Checkout."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your WooCommerce integration, check out their"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "extended guide."
									}
								]
							]
						},
						{
							"title": "Configure your settings",
							"step_instructions": [
								[
									{
										"text": "Configure the settings for your Klarna Checkout. Note that the “Title” field is used to set the title for the payment method displayed in your checkout and order confirmation emails (i.e. Klarna Checkout)."
									}
								],
								[
									{
										"text": "Tick the checkbox “Test mode” if you want to create orders using test credentials."
									}
								],
								[
									{
										"text": "It’s now time to fill out Country settings. If you’re based in Europe, click “expand” on the Europe section. If you’re based in the US, click “expand” on the United States section."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your WooCommerce integration, check out their"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "extended guide."
									}
								]
							]
						},
						{
							"title": "Add your Klarna API credentials",
							"step_instructions": [
								[
									{
										"text": "Add your Klarna API credentials in the fields Klarna API username and Klarna API password."
									}
								],
								[
									{
										"text": "Save your settings."
									}
								],
								[
									{
										"text": "Last thing to do is to set Klarna Checkout as the default payment method. Go to “Settings” and then “Payments” in your WooCommerce panel. Find the section “Payment methods” and set Klarna Checkout as the default payment method."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your WooCommerce integration, check out their"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "extended guide."
									}
								]
							]
						},
						{
							"title": "Final steps",
							"step_instructions": [
								[
									{
										"text": "Make sure to enable"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "pretty permalinks"
									},
									{
										"text": "in your WordPress installation. Otherwise callbacks from Klarna to your store won’t work and orders will not be updated with the correct order status/information."
									}
								],
								[
									{
										"text": "If you want to handle your Klarna order directly in WooCommerce you need to install the"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "Klarna Order Management"
									},
									{
										"text": "plugin."
									}
								],
								[
									{
										"text": "Make sure Klarna Checkout displays as expected by adding an item to your cart and proceeding to the checkout (Do not actually place the order)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your WooCommerce integration, check out their"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "extended guide."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Generate and save your Klarna API credentials",
							"step_instructions": [
								[
									{
										"text": "Generate new API credentials and download the file to your computer. Open the file and keep it open, as you'll need these API credentials in the next section."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your WooCommerce integration, follow the"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "extended integration guide."
									}
								]
							]
						},
						{
							"title": "Install and enable the Klarna Payment Method Plugin",
							"step_instructions": [
								[
									{
										"text": "Install the"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "Klarna Payment Method plugin for WooCommerce."
									}
								],
								[
									{
										"text": "In your WooCommerce account Go to"
									},
									{
										"bold": "Settings → Payments → Klarna Payment Method."
									}
								],
								[
									{
										"text": "Enable Klarna Payment Method by checking the Enable Klarna Payment Method checkbox."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your WooCommerce integration, follow the"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "extended integration guide."
									}
								]
							]
						},
						{
							"title": "Configure your country settings",
							"step_instructions": [
								[
									{
										"text": "Fill out Country settings. Each Klarna country has its own set of country specific settings. By adding merchant credentials to a specific country you also enable Klarna Payment Method as an available payment method for that country."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your WooCommerce integration, follow the"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "extended integration guide."
									}
								]
							]
						},
						{
							"title": "Enter your Klarna API credentials",
							"step_instructions": [
								[
									{
										"text": "Enter your Klarna API credentials in the fields Klarna API username and Klarna API password."
									}
								],
								[
									{
										"text": "Save your settings."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your WooCommerce integration, follow the"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "extended integration guide."
									}
								]
							]
						},
						{
							"title": "Place a trial purchase",
							"step_instructions": [
								[
									{
										"text": "In order to verify that the integration is set up correctly, please place a trial purchase on your store."
									}
								],
								[
									{
										"text": "After placing the order, go to"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Orders in Merchant Portal,"
									},
									{
										"text": "find your order and cancel it, to avoid paying for it yourself."
									}
								],
								[
									{
										"text": "Once your integration is successful, the banner at the top of this page will turn green and show the words \"Integration Completed\"."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your WooCommerce integration, follow the"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "extended integration guide."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Configure your settings to enable Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "First off, make sure you’ve installed the Klarna Checkout module for Magento. If you don’t have the module yet, head to"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "this page"
									},
									{
										"text": "to get it."
									}
								],
								[
									{
										"text": "Once you have your Klarna API credentials, open your Magento panel. Go to “Stores” → ”Configuration” → ”Sales” → ”Payment methods” → ”Klarna” → ”Klarna API”."
									}
								],
								[
									{
										"text": "Expand the “Klarna API” section and fill in your API version, Klarna API username, and Klarna API password. Make sure to disable test mode if you are ready to go live on your site."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Magento integration, check out their"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "extended guide."
									}
								]
							]
						},
						{
							"title": "Final steps",
							"step_instructions": [
								[
									{
										"text": "When your settings is configured, You need to check that Klarna checkout is set as enabled in your checkout options."
									}
								],
								[
									{
										"text": "Go to “Stores” → ”Configuration” → ”Sales” → ”Checkout” → ”Klarna Checkout options”, in your Magento panel."
									}
								],
								[
									{
										"text": "Klarna Checkout should be enabled as default. If not, change to"
									},
									{
										"bold": "Enable"
									},
									{
										"text": "under “Enable Klarna Checkout”."
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Generate and save your Klarna API credentials",
							"step_instructions": [
								[
									{
										"text": "Generate new API credentials and download the file to your computer. Open the file and keep it open, as you'll need these API credentials in the next section."
									}
								]
							]
						},
						{
							"title": "Install and Activate the Klarna Payment Method Module",
							"step_instructions": [
								[
									{
										"text": "Visit the"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "Setting Up Klarna on the  Magento User Guide"
									},
									{
										"text": "and follow the instructions there to install and configure the module on your Magento account."
									}
								]
							]
						},
						{
							"title": "Place a trial purchase",
							"step_instructions": [
								[
									{
										"text": "In order to verify that the integration is set up correctly, please place a trial purchase on your store."
									}
								],
								[
									{
										"text": "After placing the order, go to"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Orders in Merchant Portal,"
									},
									{
										"text": "find your order and cancel it, to avoid paying for it yourself."
									}
								],
								[
									{
										"text": "Once your integration is successful, the banner at the top of this page will turn green and show the words \"Integration Completed\"."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Enable the Klarna Payment Method plugin for Shopware",
							"step_instructions": [
								[
									{
										"text": "First off, make sure you’ve installed the Klarna Payment Method plugin for Shopware. If you don’t have the plugin yet, head to"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "this page"
									},
									{
										"text": "to get it."
									}
								],
								[
									{
										"text": "In a next step you need to import the Klarna Payment Method plugin into Shopware by clicking through"
									},
									{
										"bold": "Configuration → Plugin Manager → Installed → Upload Plugin."
									},
									{
										"text": "Click"
									},
									{
										"bold": "Select"
									},
									{
										"text": "and select the Klarna Payment Method Plugin ZIP file. Confirm by clicking"
									},
									{
										"bold": "Upload Plugin."
									},
									{
										"text": "The plugin can now be found in the plugin manager."
									}
								],
								[
									{
										"text": "Install the plugin by clicking on the"
									},
									{
										"bold": "green “+”"
									},
									{
										"text": "icon."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Configure the Klarna Payment Method plugin for Shopware",
							"step_instructions": [
								[
									{
										"text": "Navigate to the Plugin settings by clicking"
									},
									{
										"bold": "Configuration → Basic settings → Search for Klarna Payment Method"
									}
								],
								[
									{
										"text": "Enter your Klarna API credentials in the fields"
									},
									{
										"bold": "Klarna API username"
									},
									{
										"text": "and"
									},
									{
										"bold": "Klarna API password"
									},
									{
										"text": "and save your changes."
									}
								],
								[
									{
										"text": "Please make sure you are using the live mode and use your Klarna API credentials."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Configure your Klarna Payment Method gateway(s)",
							"step_instructions": [
								[
									{
										"text": "Before using Klarna you need to activate your Klarna Payment Method gateway(s). You can find these by clicking"
									},
									{
										"bold": "Configuration → Payment methods"
									}
								],
								[
									{
										"text": "By default all Klarna Payment Method gateways are installed. Open the Klarna Payment Method gateways you signed up for and activate them by ticking the"
									},
									{
										"bold": "Activated"
									},
									{
										"text": "tick box. Save your changes."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Configure your shipping cost",
							"step_instructions": [
								[
									{
										"text": "Configure your shipping costs for your Klarna Payment Method gateway(s) by clicking"
									},
									{
										"bold": "Configuration → Shipping cost"
									}
								],
								[
									{
										"text": "Select the shipping methods that should be available for Klarna by clicking the"
									},
									{
										"bold": "pencil icon."
									}
								],
								[
									{
										"text": "Select the tab payment method selection and move your Klarna Payment Method gateway(s) from"
									},
									{
										"bold": "Available"
									},
									{
										"text": "to"
									},
									{
										"bold": "Selected."
									},
									{
										"text": "Save your settings"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Activate your Klarna Payment Method plugin",
							"step_instructions": [
								[
									{
										"text": "Next you need to activate the Klarna Payment Method plugin. Click through"
									},
									{
										"bold": "Configuration → Plugin Manager → Installed"
									},
									{
										"text": "to reach the Plugin Manager."
									}
								],
								[
									{
										"text": "Activate the Plugin by clicking on the"
									},
									{
										"bold": "red “X”"
									},
									{
										"text": "icon."
									}
								],
								[
									{
										"text": "You will be asked if you want to empty the cache. Click on"
									},
									{
										"bold": "Yes."
									},
									{
										"text": "Please note you need to clear cache and compile themes everytime you change something in the module settings or payment methods from Klarna."
									}
								],
								[
									{
										"text": "To fully activate the Klarna Payment Method plugin the shop theme needs to be re-compiled. Click on"
									},
									{
										"bold": "Compile themes"
									},
									{
										"text": "when asked."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Final steps",
							"step_instructions": [
								[
									{
										"text": "To avoid any rounding errors please make sure you have the PHP extension bcmath installed on your server. Please find the guide"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "here"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Restart your backend once to make sure all Configurations are available in your shop."
									}
								],
								[
									{
										"text": "Make sure your Klarna Payment product(s) displays as expected by adding an item to your cart, choosing Klarna as payment method, and proceeding to the checkout (Do not actually place the order)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "extended guide. (in German)"
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "Enable the Klarna Checkout plugin for Shopware",
							"step_instructions": [
								[
									{
										"text": "First off, make sure you’ve installed the Klarna Checkout plugin for Shopware (Version 5.2.17 and later). If you don’t have the plugin yet, head to"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "this page"
									},
									{
										"text": "to get it."
									}
								],
								[
									{
										"text": "In a next step you need to import the Klarna Checkout plugin into Shopware by clicking through"
									},
									{
										"bold": "Configuration → Plugin Manager → Installed → Upload Plugin."
									},
									{
										"text": "Click"
									},
									{
										"bold": "Select"
									},
									{
										"text": "and select the Klarna Checkout Plugin ZIP file. Confirm by clicking"
									},
									{
										"bold": "Upload Plugin."
									},
									{
										"text": "The plugin can now be found in the plugin manager."
									}
								],
								[
									{
										"text": "Install the plugin by clicking on the"
									},
									{
										"bold": "green “+”"
									},
									{
										"text": "icon."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Configure the Klarna Checkout plugin for Shopware",
							"step_instructions": [
								[
									{
										"text": "Navigate to the Plugin settings by clicking"
									},
									{
										"bold": "Configuration → Basic settings → Search for Klarna Checkout"
									}
								],
								[
									{
										"text": "Enter your Klarna API credentials in the fields"
									},
									{
										"bold": "Klarna API username"
									},
									{
										"text": "and"
									},
									{
										"bold": "Klarna API password"
									},
									{
										"text": "and save your changes."
									}
								],
								[
									{
										"text": "Please make sure you are using the live mode and use your Klarna API credentials."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Activate Klarna Checkout payment gateway",
							"step_instructions": [
								[
									{
										"text": "Before using Klarna you need to activate your Klarna Payment gateway. You can find these by clicking"
									},
									{
										"bold": "Configuration → Payment methods"
									}
								],
								[
									{
										"text": "Open the Klarna Checkout gateway and activate it by ticking the"
									},
									{
										"bold": "Activated"
									},
									{
										"text": "tick box. Save your changes."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Configure your shipping cost",
							"step_instructions": [
								[
									{
										"text": "Configure your shipping costs for your Klarna Checkout by clicking"
									},
									{
										"bold": "Configuration → Shipping cost"
									}
								],
								[
									{
										"text": "Select the shipping methods that should be available for Klarna by clicking the"
									},
									{
										"bold": "pencil icon."
									}
								],
								[
									{
										"text": "Select the tab payment method selection and move your Klarna Checkout from"
									},
									{
										"bold": "Available"
									},
									{
										"text": "to"
									},
									{
										"bold": "Selected."
									},
									{
										"text": "Save your settings"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Activate your Klarna Checkout plugin",
							"step_instructions": [
								[
									{
										"text": "Next you need to activate the Klarna Checkout plugin. Click through"
									},
									{
										"bold": "Configuration → Plugin Manager → Installed"
									},
									{
										"text": "to reach the Plugin Manager."
									}
								],
								[
									{
										"text": "Activate the Plugin by clicking on the"
									},
									{
										"bold": "red “X”"
									},
									{
										"text": "icon."
									}
								],
								[
									{
										"text": "You will be asked if you want to empty the cache. Click on"
									},
									{
										"bold": "Yes."
									}
								],
								[
									{
										"text": "To fully activate the Klarna Checkout plugin the shop theme needs to be re-compiled. Click on"
									},
									{
										"bold": "Compile themes"
									},
									{
										"text": "when asked."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Final steps",
							"step_instructions": [
								[
									{
										"text": "To avoid any rounding errors please make sure you have the PHP extension bcmath installed on your server. Please find the guide"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "here"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Make sure that “Additional address line 1” and “Additional address line 2” are not marked as mandatory."
									}
								],
								[
									{
										"text": "Restart your backend once to make sure all Configurations are available in your shop."
									}
								],
								[
									{
										"text": "Make sure your Klarna Checkout displays as expected by adding an item to your cart, choosing Klarna as payment method, and proceeding to the checkout (Do not actually place the order)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "extended guide. (in German)"
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Enable the Klarna Payment Method plugin for Shopware",
							"step_instructions": [
								[
									{
										"text": "To be able to install the Klarna plugin, you need a running system of Shopware 6. Installation guidelines can be found"
									},
									{
										"link": "https://docs.shopware.com/en/shopware-6-en/first-steps/installing-shopware-6",
										"text": "here."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Installation & Setup. There are several ways to install the Klarna plugin.",
							"step_instructions": [
								[
									{
										"text": "First Run Wizard."
									}
								],
								[
									{
										"text": "Installation via Administration."
									}
								],
								[
									{
										"text": "Installation via Community Store Direct Download."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Activate the Klarna Payment Method plugin for Shopware",
							"step_instructions": [
								[
									{
										"text": "Go to the overview of your plugins in the Shopware Administration. You can access this via"
									},
									{
										"bold": "Settings > System > Plugins."
									}
								],
								[
									{
										"text": "Select"
									},
									{
										"bold": "Install"
									},
									{
										"text": "from the context menu (\"...\"). You will receive a success message from Shopware that the plugin has been successfully installed."
									}
								],
								[
									{
										"text": "For security reasons, the plugin is now installed but not yet activated. You need to  optimize it with your access data and individual settings first."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Wizard",
							"step_instructions": [
								[
									{
										"text": "After the plugin has been activated, please go to the"
									},
									{
										"bold": "context menu (\"...\") > wizard.",
										"text": "You will then be forwarded to the routine."
									}
								],
								[
									{
										"text": "The routine will guide you through the entire setup process and allows you to register with Klarna if you do not yet have a dealer account."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Plugin Configuration",
							"step_instructions": [
								[
									{
										"bold": "Sales channels."
									},
									{
										"text": "Here you determine whether the following settings for \"all sales channels\" are to be or should only apply to certain individual sales channels."
									}
								],
								[
									{
										"bold": "API Settings."
									},
									{
										"text": "API user name and API password: Enter your API access data here for the live and test mode into the appropriate sections."
									}
								],
								[
									{
										"text": "You can test your Klarna API credentials by clicking the"
									},
									{
										"bold": "Test API credentials",
										"text": "button, which could be found in the header. You will then receive a success message or an indication which data seems to be incorrect."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Activate/deactivate plugin",
							"step_instructions": [
								[
									{
										"text": "If you want to activate/deactivate the Klarna Payment Method plugin or just want to see the current activation status go to the Shopware Admin and select"
									},
									{
										"bold": "Settings > System > Plugins."
									}
								],
								[
									{
										"text": "Here you can  find the current status in the table under"
									},
									{
										"bold": "\"My Plugins\"."
									}
								],
								[
									{
										"text": "The status can be changed by clicking on the Slider."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "extended guide. (in German)"
									}
								]
							]
						},
						{
							"title": "Final steps",
							"step_instructions": [
								[
									{
										"text": "To avoid any rounding errors please make sure you have the PHP version  >= 7.2."
									}
								],
								[
									{
										"text": "Complete installation of Shopware"
									},
									{
										"bold": "(Storefront + Administration, not headless)."
									}
								],
								[
									{
										"text": "The system must be accessible from outside for updating the payment status."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your Shopware integration, check out our"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "extended guide. (in German)"
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Generate and save your Klarna API credentials",
							"step_instructions": [
								[
									{
										"text": "Generate new API credentials and download the file to your computer. Open the file and keep it open, as you'll need these API credentials in the next section."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your 3dcart integration, follow the"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "extended integration guide."
									}
								]
							]
						},
						{
							"title": "Activate Klarna Payment Method in Online Store Manager",
							"step_instructions": [
								[
									{
										"text": "Log in to your"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "3dcart Online Store Manager,"
									},
									{
										"text": "and navigate to"
									},
									{
										"bold": "Settings → Payment."
									}
								],
								[
									{
										"text": "On the Payment page, click on the"
									},
									{
										"bold": "Select Payment Methods"
									},
									{
										"text": "button."
									}
								],
								[
									{
										"text": "You’ll see a list of pre-installed modules. Locate the Klarna module and activate it using the toggle switch."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your 3dcart integration, follow the"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "extended integration guide."
									}
								]
							]
						},
						{
							"title": "Enter your Klarna API Credentials",
							"step_instructions": [
								[
									{
										"text": "After activating the module, enter your Klarna API Username (UID) into the provided field. You’ll find this in the credentials file you downloaded earlier."
									}
								],
								[
									{
										"text": "Next, click on the"
									},
									{
										"bold": "Password Change"
									},
									{
										"text": "link and enter your Klarna API Password into the password field."
									}
								],
								[
									{
										"text": "Under"
									},
									{
										"bold": "Language Country"
									},
									{
										"text": "select the country's language that will be used for the Klarna payment options on the store."
									}
								],
								[
									{
										"text": "Above the username field is a checkbox labeled"
									},
									{
										"bold": "\"Test Mode\"."
									},
									{
										"text": "Check this option to activate test mode, allowing you to place orders without incurring any charges or payment actions while testing the module."
									}
								],
								[
									{
										"text": "Once you're done configuring your settings, click \"Save\" at the top right."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your 3dcart integration, follow the"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "extended integration guide."
									}
								]
							]
						},
						{
							"title": "Place a trial purchase",
							"step_instructions": [
								[
									{
										"text": "In order to verify that the integration is set up correctly, please place a trial purchase on your store."
									}
								],
								[
									{
										"text": "After placing the order, go to"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Orders in Merchant Portal,"
									},
									{
										"text": "find your order and cancel it, to avoid paying for it yourself."
									}
								],
								[
									{
										"text": "Once your integration is successful, the banner at the top of this page will turn green and show the words \"Integration Completed\"."
									}
								],
								[
									{
										"text": "If you turned on “Test Mode” in the previous step, go back to On sure to uncheck it and save before going live with your store, so that your real orders go through correctly."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For more detailed information about your 3dcart integration, follow the"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "extended integration guide."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Generate and save your Klarna API credentials",
							"step_instructions": [
								[
									{
										"text": "Generate new API credentials and download the file to your computer. Open the file and keep it open, as you'll need these API credentials in the next section."
									}
								]
							],
							"alternate": [
								{
									"text": "For more detailed information about your BigCommerce integration, follow the"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "extended integration guide."
								}
							]
						},
						{
							"title": "Configure your BigCommerce settings",
							"step_instructions": [
								[
									{
										"text": "In BigCommerce, go to"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Store Setup › Payments,"
									},
									{
										"text": "and expand the Online Payment Methods section. Then click"
									},
									{
										"bold": "Set up"
									},
									{
										"text": "next to Klarna Payment Method."
									}
								],
								[
									{
										"text": "You'll be taken to the Klarna Payment Method Settings tab. Enter in the API credentials file you saved in the previous section and copy the username and password into their corresponding fields."
									}
								],
								[
									{
										"text": "Save your changes when you're ready."
									}
								]
							],
							"alternate": [
								{
									"text": "For more detailed information about your BigCommerce integration, follow the"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "extended integration guide."
								}
							]
						},
						{
							"title": "Place a trial purchase",
							"step_instructions": [
								[
									{
										"text": "In order to verify that the integration is set up correctly, please place a trial purchase on your store."
									}
								],
								[
									{
										"text": "After placing the order, go to"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Orders in Merchant Portal,"
									},
									{
										"text": "find your order and cancel it, to avoid paying for it yourself."
									}
								],
								[
									{
										"text": "Once your integration is successful, the banner at the top of this page will turn green and show the words \"Integration Completed\"."
									}
								]
							],
							"alternate": [
								{
									"text": "For more detailed information about your BigCommerce integration, follow the"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "extended integration guide."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "Activate the Klarna Checkout module",
							"step_instructions": [
								[
									{
										"text": "First off, make sure you’ve installed the official Klarna module for Prestashop. If you don’t have it yet, head to"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "this page"
									},
									{
										"text": "to get it."
									}
								],
								[
									{
										"text": "Unfortunately, Starting January 1st 2023, these plug-ins developed and owned by Prestasworks A.B (SI) will no longer be distributed for free. If you’re interested in Klarna you can purchase the plug-in or wait for Klarna owned plug-ins expected to be released in Q2’23."
									}
								],
								[
									{
										"text": "Log into your Prestashop admin page, and go to"
									},
									{
										"bold": "Modules → Modules."
									}
								],
								[
									{
										"text": "Search for “Klarna” in the search bar to locate the Klarna module by Prestaworks AB. Click"
									},
									{
										"bold": "Configure."
									}
								]
							]
						},
						{
							"title": "Configure your Klarna module settings",
							"step_instructions": [
								[
									{
										"text": "You are now on the module settings page. At the top of “General settings” you will see a button called"
									},
									{
										"bold": "Activate KCO in this shop"
									},
									{
										"text": "(Klarna Checkout V3). Choose"
									},
									{
										"bold": "Yes."
									}
								],
								[
									{
										"text": "Click"
									},
									{
										"bold": "Save"
									},
									{
										"text": "to save your settings."
									}
								],
								[
									{
										"text": "Now, click on your sales country in the left hand menu, and enter your Klarna API credentials under"
									},
									{
										"bold": "Klarna API username"
									},
									{
										"text": "and"
									},
									{
										"bold": "Klarna API password."
									}
								],
								[
									{
										"text": "Click"
									},
									{
										"bold": "Save."
									}
								]
							]
						},
						{
							"title": "Final steps",
							"step_instructions": [
								[
									{
										"text": "Control that test mode is disabled if you are ready to go live on your site. You can do so under the tab"
									},
									{
										"bold": "Common Settings."
									},
									{
										"text": "The button"
									},
									{
										"bold": "Testdrive"
									},
									{
										"text": "should be set to"
									},
									{
										"bold": "No."
									}
								],
								[
									{
										"text": "While in"
									},
									{
										"bold": "Common Settings,"
									},
									{
										"text": "make sure to set up your settings for how you want to handle orders, settings for invoice-sendouts, etc."
									}
								],
								[
									{
										"text": "Make sure your Klarna Checkout display as expected by adding an item to your cart, and proceeding to the checkout (Do not actually place the order)."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Generate and save your Klarna API credentials",
							"step_instructions": [
								[
									{
										"text": "Generate new API credentials and download the file to your computer. Open the file and keep it open, as you'll need these API credentials in the next section."
									}
								]
							]
						},
						{
							"title": "Install and Activate the Klarna Payment Method Module",
							"step_instructions": [
								[
									{
										"text": "Open the"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "Klarna Payment Method Prestashop instructions page"
									},
									{
										"text": "and follow the instructions there to install and configure the module on your Prestashop account."
									}
								]
							]
						},
						{
							"title": "Place a trial purchase",
							"step_instructions": [
								[
									{
										"text": "In order to verify that the integration is set up correctly, please place a trial purchase on your store."
									}
								],
								[
									{
										"text": "After placing the order, go to"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Orders in Merchant Portal,"
									},
									{
										"text": "find your order and cancel it, to avoid paying for it yourself."
									}
								],
								[
									{
										"text": "Once your integration is successful, the banner at the top of this page will turn green and show the words \"Integration Completed\"."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Generate your Klarna API credentials.",
							"step_instructions": [
								[
									{
										"text": "You will need these credentials to integrate Klarna in your store."
									}
								]
							]
						},
						{
							"title": "Add Klarna as new payment method.",
							"step_instructions": [
								[
									{
										"text": "On Jumpseller Admin Panel and navigate to Settings > Payments, find “Klarna” on the checkbox list and click “Add Method”."
									}
								]
							]
						},
						{
							"title": "Configure our new payment method.",
							"step_instructions": [
								[
									{
										"text": "On the Klarna configuration panel (Jumpseller Admin Panel and navigate to Settings > Payments > Klarna), (i) add the Klarna API Credentials generated on first step, (ii) select the EMD packages you want/need to share with Klarna , and (iii) select if you need to auto capture the orders (default is no)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Integrate Lightspeed eCom",
							"step_instructions": [
								[
									{
										"text": "See the integration guide in"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "English"
									},
									{
										"text": "and in"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Dutch"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Integrate Shoper",
							"step_instructions": [
								[
									{
										"text": "See the integration guide on"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "the Shoper website"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Integrate Timma",
							"step_instructions": [
								[
									{
										"text": "See the integration guide on"
									},
									{
										"link": "https://help.timma.fi/sv/articles/4990994-betalning-via-klarna",
										"text": "the Timma website"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Generate and save your Klarna API credentials",
							"step_instructions": [
								[
									{
										"text": "Generate new API credentials and download the file to your computer. Open the file and keep it open, as you'll need these API credentials in the next section."
									}
								]
							]
						},
						{
							"title": "Integrate with SmartEtailing",
							"step_instructions": [
								[
									{
										"text": "Follow the instructions on"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "the SmartEtailing website."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Generate and save your Klarna API credentials",
							"step_instructions": [
								[
									{
										"text": "Generate new API credentials and download the file to your computer. Open the file and keep it open, as you'll need these API credentials in the next section."
									}
								]
							]
						},
						{
							"title": "Integrate with Workstand",
							"step_instructions": [
								[
									{
										"text": "Follow the instructions on"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "the Workstand website."
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Read the documentation for our plugin",
							"step_instructions": [
								[
									{
										"text": "Head to our"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "documentation page"
									}
								]
							]
						},
						{
							"title": "Activate the Klarna Checkout module for JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Please make sure you’ve installed the official Klarna extension. If you don’t have it yet,"
									},
									{
										"text": "head to"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "this page"
									},
									{
										"text": "to get it."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Read the documentation for our plugin",
							"step_instructions": [
								[
									{
										"text": "Head to our"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "documentation page"
									}
								]
							]
						},
						{
							"title": "Activate the Klarna Payments module for JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Please make sure you’ve installed the official Klarna extension. If you don’t have it yet,"
									},
									{
										"text": "head to"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "this page"
									},
									{
										"text": "to get it."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Here's what you need to do next",
							"step_instructions": [
								[
									{
										"bold": "Generate your Klarna API credentials."
									},
									{
										"text": "You need these credentials to integrate Klarna in your store."
									}
								],
								[
									{
										"bold": "Add the Klarna API credentials in your back end system to enable Klarna."
									},
									{
										"text": "Check out our"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "Developer Portal"
									},
									{
										"text": "for more support."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "First Name",
							"error": "Please enter a first name"
						},
						"last_name": {
							"label": "Last Name",
							"error": "Please enter a last name"
						},
						"dateOfBirth": {
							"label": {
								"default": "Date of birth (DD/MM/YYYY)",
								"without_format": "Date of birth",
								"US": "Date of birth (MM/DD/YYYY)"
							},
							"error": "Enter a valid date",
							"error_too_young": "You need to be at least 18 years old to sell with Klarna"
						},
						"address": {
							"label": "Residential address",
							"error": "Please enter an address"
						},
						"city": {
							"label": "City",
							"error": "Please enter a city"
						},
						"country": {
							"label": "Country",
							"error": "Please select a country"
						},
						"postal_code": {
							"label": {
								"default": "Postal code",
								"US": "ZIP code"
							},
							"error": {
								"default": "Please enter a valid postal code",
								"US": "Please enter a valid ZIP code"
							}
						},
						"region": {
							"label": "State/region (optional)",
							"label_summary": "State/region"
						},
						"state": {
							"label": "State",
							"error": "Please enter a state"
						},
						"role_question": {
							"OWNER": "Is this person an owner?",
							"BENEFICIAL_OWNER": "Does this person control more than 25% of shares or voting rights?",
							"ULTIMATE_BENEFICIAL_OWNER": "This individual owns or controls more than 25% of shares or voting rights"
						},
						"is_person_pep": [
							{
								"text": "Is this individual a"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "politically exposed person (PEP)"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "immediate family"
							},
							{
								"text": "or"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "known co-worker"
							},
							{
								"text": "of such a person?"
							}
						],
						"pep_relationship": {
							"label": "Relationship",
							"error": "Please select the relationship this person has to a PEP"
						},
						"pep_position": {
							"label": "PEP-position",
							"error": "Please select the position the PEP holds"
						},
						"personal_id_question": "This person does not have a Personal Identification Number",
						"personal_id": {
							"US": {
								"label": "Social Security Number (Last 4 digits)",
								"label_summary": "Social Security Number"
							},
							"US_FULL_SSN": {
								"label": "Social Security Number",
								"label_summary": "Social Security Number"
							},
							"CA": {
								"label": "Social Insurance Number (SIN) or Passport Number",
								"label_summary": "Social Insurance Number (SIN) or Passport Number"
							},
							"SE": {
								"label": "Personal Identification Number (PNO)",
								"label_summary": "Personal Identification Number (PNO)"
							},
							"FI": {
								"label": "Personal Identification Code (HETU)",
								"label_summary": "Personal Identification Number (HETU)"
							},
							"NO": {
								"label": "National Identity Number",
								"label_summary": "National Identity Number"
							},
							"DK": {
								"label": "Personal Identification Number",
								"label_summary": "Personal Identification Number (CPR)"
							},
							"IT": {
								"label": "Fiscal Code",
								"label_summary": "Fiscal code"
							},
							"ES": {
								"label": "Personal Identification Number",
								"label_summary": "Personal Identification Number (DNI)"
							},
							"PL": {
								"label": "Personal Identification Number",
								"label_summary": "Personal Identification Number (PESEL)"
							},
							"default": {
								"label": "Passport Number",
								"label_summary": "Passport Number"
							},
							"value": "Confidential"
						},
						"registration_number": {
							"label": "Enterprise Identification Number",
							"error": "Please enter EIN in format: XX-XXXXXXXXX"
						},
						"company_name": {
							"label": "Store name",
							"error": "Please provide a valid Company Name"
						},
						"legal_company_name": {
							"label": "Legal name of the company",
							"error_label": "Please provide the legal name of the company"
						},
						"add_person": "Add person",
						"remove": "Remove",
						"edit": "Edit"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "Merchant ID: {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Marketing material",
						"text": "Now you're part of the Klarna family. Here's a pack of material and more to get you going.",
						"link": "Download"
					},
					"invite_more_users": {
						"title": "Invite more users",
						"text": "Invite your collaborators to the Merchant Portal, you will be able to set custom permissions for each of them!",
						"link": "Invite users"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Products and pricing",
					"subtitle": "{country}",
					"pricing": "Pricing for {country}",
					"monthly_fee": "monthly fee",
					"transaction_fee": "transaction fee",
					"before_link": "I agree to Klarna",
					"link_text": "terms & conditions",
					"after_link_one_product": "for this product",
					"after_link_more_than_one_product": "for these products",
					"product_not_available_in_your_country": "* This product is not available for your home market, but it will work in other countries."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Installed"
						},
						"in_progress": {
							"text": "In Progress"
						}
					}
				},
				"phone_collection_block": {
					"title": "Having trouble with your Klarna integration?",
					"description": "Leave your number below and one of our agents will call you to support you in adding Klarna to your e-commerce.",
					"success_banner": "Thanks! Our team will get back to you ASAP.",
					"submit": "Send",
					"fields": {
						"phone": {
							"label": "Phone number",
							"tooltip": "You need to include the country code, e.g. +1 541 754 3010",
							"errors": {
								"required": "Phone number is required",
								"invalid": "Invalid phone number"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "Who signs the contracts for your company?",
						"managed": "Who signs the contracts for the company?",
						"recollection": "Who is authorized to sign on behalf of your business?"
					},
					"subtitle": {
						"unmanaged": "Your business is about to conclude a contract with Klarna. We need to verify who is legally authorized to sign contracts.",
						"managed": "Please provide the information about all authorized signatories of the company that enter the agreement. We are legally required to validate the signing authority of these representatives. If no one from the list signed the agreement click “Add person” and provide the required information.",
						"recollection": "As your business has an active agreement with Klarna, we are legally obligated to collect and verify information on all your legal representatives."
					},
					"form_title": "Please enter the information",
					"robot_message": {
						"unmanaged": "These are usually the directors of the board or executives such as the CEO, CFO or COO. Entering two or more people can help speed up the contract approval.",
						"managed": "These are usually the directors of the board or executives such as the CEO, CFO or COO. Entering two or more people can help speed up the contract approval."
					},
					"error_tooltip": {
						"too_young": "This person can't submit the application because they are under {minAge} years old."
					},
					"alert_all_too_young": "All persons entering the agreement must be over {minAge} years old. To continue, please add and select an applicant who is over {minAge} years old.",
					"buttons": {
						"next": "Next",
						"back": "Back",
						"add_person": "+ Add person"
					},
					"role": {
						"recollection": "Legal Representative"
					}
				},
				"application_summary": {
					"title": "Review and submit your application.",
					"subtitle": {
						"unmanaged": "Take a look at your details before submitting.",
						"managed": "Take a look at the details before submitting."
					},
					"stakeholders": {
						"title": "Company management",
						"subtitle": "Stakeholder {index}"
					},
					"businessDetailsCard": {
						"title": "Business details"
					},
					"businessDetailsCardFields": {
						"companyName": "Company Name",
						"organizationEntityType": "Tax classification",
						"organizationRegistrationAuthority": "Registration Court",
						"goodsCategory": "Goods Category",
						"registrationId": {
							"default": "Registration Number",
							"AT": "Registration number",
							"AU": "ACN",
							"CA": "Business Number",
							"ES": "Company NIF/NIE/DNI",
							"GB": "Organization number",
							"GR": "G.E.MI. number (Γ.Ε.ΜΗ.)",
							"NZ": "Business number",
							"US": "Employer Identification Number"
						},
						"registered": {
							"default": "Registered Company",
							"AU": "Company has an ACN"
						},
						"subjectToVat": {
							"default": "Company Subject to VAT",
							"AU": "Company Subject to ABN"
						},
						"vatId": {
							"default": "VAT Number",
							"AU": "ABN",
							"NZ": "GST number",
							"ES": "Company NIF/NIE/DNI"
						},
						"storeName": "Store Name",
						"storeName_us": "Brand name / DBA",
						"website": "Website",
						"email": "Customer support email",
						"entityType": "Entity type"
					},
					"companyRegistrationAddressCard": {
						"title": "Company registration address"
					},
					"companyAddressCard": {
						"title": "Company address"
					},
					"operatingAddressCard": {
						"title": "Operational company address"
					},
					"documentsCard": {
						"title": "Uploaded documents"
					},
					"buttons": {
						"edit": "Edit",
						"back": "Back",
						"submit": "Submit"
					},
					"noTermsAccepted": "Please read and accept the terms & conditions",
					"noTermsAcceptedWithPricingAnnex": "Please read and accept the Merchant Agreement and Pricing Terms"
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "Who manages the company?"
					},
					"subtitle": {
						"default": [
							{
								"text": "We are legally required by the EU anti-money laundering directive ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") to collect this information."
							}
						],
						"US": [
							{
								"text": "As a financial institution we are legally required to collect this information."
							}
						],
						"CA": [
							{
								"text": "As a financial institution we are legally required to collect this information."
							}
						],
						"AU": [
							{
								"text": "As a financial institution we are legally required to collect this information."
							}
						]
					},
					"infobox": {
						"default": "Please enter the personal information and residential address of the CEO of the company.",
						"US": "Please enter the personal information and residential address of the majority owner or a high-level manager such as the CEO, CFO or COO.",
						"CA": "Please enter the personal information and residential address of the majority owner or a high-level manager such as the CEO, CFO or COO."
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "Is this business a public company or solely owned by a public company?",
					"title_stakeholder": "Who manages the company?",
					"subtitle": "As a financial institution we are legally required to collect this information.",
					"subtitle_stakeholder": "Please enter the personal information and residential address of the CEO of the company.",
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"bank_account": {
					"title": {
						"default": "What are your bank account details?"
					},
					"subtitle": {
						"US": "Klarna transactions will be transferred to this bank account.",
						"default": "We will use these bank account details to transfer the payments from your sales."
					},
					"no_more_bank_accounts": "You have already added bank accounts for all supported currencies. Great job!",
					"robot_message_general": "The default bank account must be with a bank in the country where the company is registered. You will also need to add a bank account for each currency you plan to accept.",
					"robot_message": "IBAN stands for International Bank Account Number and is provided by your bank for your account. Eg: GB98 MIDL 0700 9312 3456 78",
					"robot_message_account_number": {
						"AU": "Account Number is provided by your bank and has between 6 and 10 digits. Eg: 12345678",
						"US": "Account Number is provided by your bank and has between 5 and 17 digits. Eg: 12345678",
						"GB": "Account Number is provided by your bank and has 8 digits. Eg: 12345678. Some banks in the UK offer shorter account numbers (i.e. 7 digits). In this case zeros will be added at the start of your number to make the length up to 8."
					},
					"robot_message_revolut": "The IBAN that you provided is not able to receive domestic GBP payments. You will need to contact your bank and request account details which support domestic GBP transfers.",
					"robot_message_local": "The IBAN that you provided is a local IBAN for your bank, which is unsupported by us. You will need to contact your bank and request your personal IBAN or use a different account to connect with Klarna.",
					"buttons": {
						"add_bank_account": "+ Add bank account",
						"skip": "Skip (for now)",
						"remove": "Remove",
						"submit": "Submit",
						"next": "Next",
						"back": "Back"
					},
					"fields": {
						"currency_code": {
							"label": "Currency",
							"disable_reason": {
								"account_in_merchant_currency_required": "The default currency is {currency} because of the country your company is registered in."
							},
							"errors": {
								"general": "Please select a currency"
							}
						},
						"country_of_bankaccount": {
							"label": "Country",
							"errors": {
								"general": "Please select a country"
							}
						},
						"iban_account_number": {
							"label": "Account Number (IBAN)",
							"errors": {
								"general": "Please enter a bank account number (IBAN)"
							}
						},
						"use_as_default_bank_account": {
							"label": "Use this account for unspecified currencies",
							"tooltip": "Orders with currencies not listed on this page will be paid out to this account. Your bank may charge an additional fee for some currencies."
						},
						"local_account_number": {
							"label": {
								"default": "Account Number",
								"MX": "CLABE number"
							},
							"errors": {
								"general": {
									"default": "Please enter a bank account number",
									"MX": "Please enter a valid CLABE number"
								}
							}
						},
						"account_holder": {
							"label": "Account holder name",
							"errors": {
								"general": "Please enter the account holder's name. (Maximum 70 characters)"
							}
						},
						"transit_number": {
							"label": "Transit number",
							"errors": {
								"general": "Please enter a valid transit number"
							}
						},
						"institution_number": {
							"label": "Institution number",
							"errors": {
								"general": "Please enter a valid institution number"
							}
						},
						"bic": {
							"label": {
								"AU": "BSB"
							},
							"errors": {
								"general": {
									"AU": "Please enter a valid BSB (bank state branch)"
								}
							},
							"tooltip": {
								"AU": "BSB code should be 6 numerical digits split by a -. E.g: 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Routing Number",
								"GB": "Sort code"
							},
							"errors": {
								"general": {
									"default": "Please enter a valid routing number",
									"GB": "Please enter a valid sort code"
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "Who manages the company?"
					},
					"subtitle": {
						"default": [
							{
								"text": "We are legally required by the EU anti money laundering directive ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") to collect this information."
							}
						],
						"GB": [
							{
								"text": "We are legally required to collect this information. Please make sure your record in Companies House is up-to-date."
							}
						]
					},
					"infobox": "Please enter the personal information and residential address of individuals that exercise control over your company’s management, such as the Managing Director or board members.",
					"buttons": {
						"next": "Next",
						"back": "Back",
						"add_person": "+ Add person"
					},
					"messages": {
						"lookup": "Do these people manage your company? Please have a look and confirm if correct."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "Is your business a registered company?",
						"managed": "Is this business a registered company?"
					},
					"subtitle": {
						"unmanaged": "We need your company registration number to verify your business details.",
						"managed": "We need the company registration number to verify the company business details."
					},
					"question": {
						"title": {
							"unmanaged": "Please enter your registration number and registration court",
							"managed": "Please enter the registration number and registration court"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Registration number"
						},
						"registration_court": {
							"label": "Registration court",
							"errors": {
								"general": {
									"unmanaged": "Please select your registration court",
									"managed": "Please select the registration court"
								}
							}
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"documents": {
					"title": "Upload your documents",
					"subtitle": "We require you to send us few pieces of additional documentation needed for us to validate your identity. Upload only <strong>JPG</strong>, <strong>PNG</strong> or <strong>PDF</strong> files (maximum file size 10 MB).",
					"subheadline": {
						"default": "As Klarna is a bank headquartered in Sweden, and therefore regulated under the control of the Swedish Financial Supervisory Authority, Klarna must comply with EU Directive EU 2015/849. Klarna needs to collect information about the people who control the company, so you can start using Klarna's services. Please upload only <strong>JPG, PNG or PDF</strong> files (max. file size 10MB)",
						"US": "As Klarna is a bank headquartered in Sweden, and therefore regulated under the control of the Swedish Financial Supervisory Authority, Klarna must comply with EU Directive EU 2015/849. Klarna is required to collect information about the people who control the company, so you can start using Klarna's services. Please provide the following documentation for us to validate your identity. Upload only JPG, PNG or PDF files (maximum file size 10 MB).",
						"IT": "As Klarna is a bank headquartered in Sweden, and therefore regulated under the control of the Swedish Financial Supervisory Authority, Klarna must comply with EU Directive EU 2015/849. Klarna needs to collect information about the people who control the company, so you can start using Klarna's services. Kindly note that in order to proceed with the application, your company needs to be registered with the Chamber of Commerce. Please upload only JPG, PNG or PDF files (max. files size 10MB)"
					},
					"header_title": "Documents",
					"stakeholder": "Stakeholder",
					"business_documents": "Business documents",
					"browse_files": "Browse Files",
					"optional": "(optional)",
					"upload_area": {
						"title": {
							"before_link": "Drop your files here or",
							"link_text": "Select files"
						},
						"description": "{acceptedFileFormats} - Maximum {maxFileSizeMB}MB/file"
					},
					"description": {
						"APPROVAL": "Upload <strong>approval</strong>",
						"CONTRACT": "Upload <strong>contract</strong>",
						"CORRECTION_NOTE": "Upload <strong>correction note</strong>",
						"COUNTERSIGNED_CONTRACT": "Upload <strong>countersigned contract</strong>",
						"ID_DOCUMENT": "Upload <strong>ID</strong> or <strong>passport</strong>",
						"LICENSE": "Upload <strong>license</strong>",
						"PROOF_OF_ADDRESS": "Upload <strong>proof of address</strong>",
						"SPECIAL_AGREEMENT": "Upload <strong>special agreement</strong>",
						"SUPPORTING_DOCUMENT": "Upload <strong>supporting document</strong>",
						"TAX_OFFICE_REGISTRATION": "Upload <strong>tax office registration</strong>"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Approval"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Contract"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Correction note"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Countersigned contract"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "Proof of identity",
								"IT": "Identity Card"
							},
							"subtitle": {
								"default": "Please provide both sides of the identity card.",
								"AT": "Please provide us with both sides of your ID card. If your address is not on your ID, we will need additional documentation, such as a utility bill, to verify your address.",
								"AU": "For a quicker assessment of your application please provide a valid photo ID copy such as a passport or Australian driver's license for the following individuals associated to the business: Sole trader/Partnership - the owner/s. Company - the legal representative, all directors and any shareholder holding greater than 25% of shares.",
								"BE": "Please provide both sides of the identity card, ensure that the image quality is sufficient and that all information is clearly legible.",
								"DE": "Please provide us with both sides of your ID card. If your address is not on your ID, we will need additional documentation, such as a utility bill, to verify your address.",
								"FR": "Please provide both sides of the identity card, ensure that the image quality is sufficient and that all information is clearly legible.",
								"GB": "Please provide ID, if an identity card, both sides.",
								"IT": "A valid Identity Card front/back for each of the persons listed in the application. Driver's license, passport, social security <strong>card/number cannot be accepted</strong>.",
								"NL": "Please provide both sides of the identity card, ensure that the image quality is sufficient and that all information is clearly legible.",
								"US": "Driver's license or Passport - Please provide both sides of the identity card."
							}
						},
						"LICENSE": {
							"title": {
								"default": "License"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Proof of address",
								"BE": "Proof of home residence",
								"CZ": "Proof of home residence",
								"ES": "Proof of home residence",
								"FI": "Proof of home residence",
								"FR": "Proof of home residence",
								"GR": "Proof of home residence",
								"IT": "Confirmation of address",
								"NL": "Proof of home residence",
								"PL": "Proof of home residence",
								"PT": "Proof of home residence"
							},
							"subtitle": {
								"default": "We are accepting the following documents that are not older than 3 months as a proof of home address: Electricity, water, gas, Wi-Fi bills, tax declaration or lease agreement. Should you not have any of the document, please upload any other proof of home residence and add a note with the reason.",
								"AU": "For a quicker assessment of your application please provide one of the following documents from the last 90 days to verify the home address: Utility bill, internet bill, tax declaration, or lease/rental agreement. *If you are providing a passport as your form of ID, or if your current address does not match the address on your provided ID, this step is mandatory.",
								"BE": "We are accepting the following documents that are not older than 3 months as a proof of home address: Electricity, water, gas, tax declaration or lease agreement. Should you not have any of the document, please upload any other proof of home residence and add a note with the reason.",
								"FR": "We are accepting the following documents that are not older than 3 months as a proof of home address: Electricity, water, gas, tax declaration or lease agreement. Should you not have any of the document, please upload any other proof of home residence and add a note with the reason.",
								"NL": "We are accepting the following documents that are not older than 3 months as a proof of home address: Electricity, water, gas, tax declaration or lease agreement. Should you not have any of the document, please upload any other proof of home residence and add a note with the reason.",
								"US": "We accept utility bills (gas, water, internet, phone etc), lease or mortgage with proof of address - Must not be dated older than 90 days from date of applicaiton.",
								"IT": "If your Identity Card has a different address from your current residential address, we will need an additional document to verify your current residence. We accept the following documents not older than 3 months as proof of the residence address of the persons listed in the application:"
							},
							"list": {
								"IT": [
									{
										"text": "Certificate of residence issued online (via SPID) or by the Municipality of your residence"
									},
									{
										"text": "Electricity / water / gas / Wi-fi bills"
									},
									{
										"text": "tenancy agreement"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Special agreement"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Supporting document",
								"GB": "Self portrait"
							},
							"subtitle": {
								"default": null,
								"AU": "If you sell high-value branded items, please provide 2-3 supplier invoices for those products here. Please ensure the invoice includes the products purchased, the name of the supplier, receivers name, and delivery address.",
								"GB": "Please provide a self-portrait photo holding up the ID."
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "Document of registration with the tax office",
								"AT": "Document on registration with the tax authority",
								"AU": "Trust Deed",
								"BE": "VAT number enabled for cross-border transactions (VIES).",
								"DE": "Document on registration with the tax authority",
								"FR": "VAT number enabled for cross-border transactions (VIES).",
								"IT": "VAT number enabled for cross-border transactions (VIES).",
								"NL": "VAT number enabled for cross-border transactions (VIES).",
								"NO": "Tax office registration",
								"US": "EIN Letter"
							},
							"subtitle": {
								"default": null,
								"AT": "We are accepting the following documents as business documents: Commercial register excerpt / sole trader license",
								"AU": "If your ABN is associated with a trust, please provide a copy of the trust document, including the trust schedule. Please note, this step is mandatory for trusts.",
								"BE": "Verify that your VAT number is <link>enabled for cross-border transactions</link>. This is be necessary even if you only trade in your local country, as Klarna is a foreign entity. You can contact your local Tax Office to request a free VIES activation of your VAT number.",
								"CZ": "We are accepting the following documents as business documents: Certificate of entry in the Public Registry, or extract from sole proprietorship trade register.",
								"DE": "We are accepting the following documents as business documents: Commercial register excerpt / sole trader license",
								"ES": "We are accepting the following documents as business documents: Deeds of incorporation for registered businesses; for sole traders - Census situation Certificate / Model 036 / Model 037",
								"FI": "We are accepting the following documents as business documents: Articles of incorporation for sole traders - Certification of census situation / Model 036 / Model 037",
								"FR": "Verify that your VAT number is <link>enabled for cross-border transactions</link>. This is be necessary even if you only trade in your local country, as Klarna is a foreign entity. You can contact your local Tax Office to request a free VIES activation of your VAT number.",
								"GR": "We are accepting the following documents as business documents: Tax office registration / Start of business / Business Registry Document issued by the Competent Service GEMI (<link>Central Union of Chambers</link>)",
								"IT": "You can contact the Internal Revenue Service (Agenzia delle Entrate) to request a free VIES activation of your VAT number. This will be necessary even if you only trade in Italy, as Klarna is a foreign entity.",
								"NL": "Verify that your VAT number is <link>enabled for cross-border transactions</link>. This is be necessary even if you only trade in your local country, as Klarna is a foreign entity. You can contact your local Tax Office to request a free VIES activation of your VAT number.",
								"NO": "We are accepting the following documents as business documents: Company papers",
								"PL": "We are accepting the following documents as business documents: Certificate of entry in the CEIDG business register, extract from the National Court Register (KRS)",
								"PT": "We are accepting the following documents as business documents:  Certidão Permanente (Obligatory), Certificate of Incorporation. For Sole Traders, Self-employment registration (Declaração de Início de Atividade).",
								"US": "This is the letter received from the IRS assigning you an EIN (IRS CP575 EIN Letter). If your business is a Sole Proprietorship and you're filing with your SSN, please provide a copy of your SSN card instead"
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Certified identification document"
							},
							"subtitle": {
								"default": "We are accepting the following documents: ID card, passport, driving licence. The documents must meet the following criteria:"
							},
							"list": [
								{
									"text": "Certified by an authorised certifying officer (for example a notary public, commissioner of oaths, lawyer, attorney, and/or certified accountant)."
								},
								{
									"text": "Signed and stamped. The stamp must display visible and verifiable details of the certifier, such as full name, address, and where applicable, registration number."
								},
								{
									"text": "Dated - certification date not older than 6 months."
								},
								{
									"text": "Attested as a true copy of an original by clearly stating that the original document was seen."
								}
							]
						}
					},
					"modal": {
						"title": "Why we need your documents?",
						"close": "Close",
						"content": [
							{
								"title": "Description of the process",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Files requirements",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "How to scan documents?",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Upload failed",
						"too_large_file": "File is too large <strong>(max {maxFileSizeMB} MB)</strong>",
						"max_num_files_exceeded": "The maximum number of {number} files is reached. If you’d like to upload another file, please first delete one.",
						"invalid_file_format": "Invalid file format. The only accepted file types are {acceptedFileFormats}",
						"duplicate_file_name": "Duplicate file name. All uploaded files must have unique names.",
						"try_again": "Try again or <u>choose another file</u>"
					},
					"buttons": {
						"modal": "Why we need your documents?",
						"next": "Next",
						"back": "Back",
						"submit": "Submit documents"
					}
				},
				"document_upload_success": {
					"title": "Upload completed.",
					"message": "Thank you! Your documents have been successfully uploaded."
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Can you please enter your registration number?",
							"AT": "Can you please enter your registration number?",
							"CA": "Can you please enter your federal BN?",
							"GR": "Can you please enter your G.E.MI. number (Γ.Ε.ΜΗ.)?",
							"NZ": "Can you please enter your business number?"
						},
						"managed": {
							"default": "Can you please enter the registration number of the company?",
							"AT": "Can you please enter the registration number of the company?",
							"CA": "Can you please enter your federal BN?",
							"GR": "Can you please enter the G.E.MI. number (Γ.Ε.ΜΗ.) of the company?",
							"NZ": "Can you please enter the business number of the company?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "We need your company registration number to verify your business details.",
							"AT": "We need your company registration number to verify your business details.",
							"CA": "We need your federal business number assigned to your company by the CRA (Canada Revenue Agency) to verify your business details.",
							"GR": "We need your G.E.MI. number to verify the business details.",
							"NZ": "We need your company business number to verify your business details."
						},
						"managed": {
							"default": "We need the company registration number to verify the business details.",
							"AT": "We need the company registration number to verify the business details.",
							"CA": "We need your federal business number assigned to your company by the CRA (Canada Revenue Agency) to verify your business details.",
							"GR": "We need the G.E.MI. number to verify the business details.",
							"NZ": "We need the company business number to verify the business details."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Please note that Klarna cannot currently provide its payment services for Canadian sole proprietorships. Proceeding with your application will lead it to be rejected."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registration number",
								"AT": "Registration number",
								"CA": "Business number",
								"GR": "G.E.MI. number (Γ.Ε.ΜΗ.)",
								"NZ": "Business number"
							}
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "What’s your tax classification?",
						"managed": "Can you please enter the company’s tax classification?"
					},
					"subtitle": {
						"unmanaged": "We’ll ask you for different pieces of information depending on the company’s legal status.",
						"managed": "We’ll ask you for different pieces of information depending on the company’s legal status."
					},
					"info": {
						"unmanaged": "You can find your business’s EIN (Employer Identification Number) on tax returns, credit reports, payroll paperwork, or licenses and permits",
						"managed": "You can find the company’s EIN (Employer Identification Number) on tax returns, credit reports, payroll paperwork, or licenses and permits"
					},
					"fields": {
						"registration_number": {
							"label": "Employer Identification Number",
							"errors": {
								"general": "Enter a valid Employer Identification Number",
								"invalid": "Employer Identification Number should be 9 digits long with a \"-\" after the first two. Eg: 12-3456789"
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Federal Tax Classification",
								"managed": "Business type"
							},
							"errors": {
								"is_one_of": "Please choose one of the listed business types"
							}
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Can you please enter your VAT number?",
							"AU": "Can you please enter your ABN?",
							"ES": "What's your tax ID number?",
							"NZ": "Can you please enter your GST number?"
						},
						"managed": {
							"default": "Can you please enter the VAT number?",
							"AU": "Can you please enter the ABN?",
							"ES": "What's your tax ID number?",
							"NZ": "Can you please enter the GST number?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "With your VAT number, we can more easily verify your company details.",
							"AU": "With your ABN, we can more easily verify your company details.",
							"NZ": "With your GST number, we can more easily verify your company details.",
							"ES": "With your NIF, NIE or DNI number, we can more easily verify your company details."
						},
						"managed": {
							"default": "We use the VAT number to verify the company details.",
							"AU": "We use the ABN to verify the company details.",
							"NZ": "We use the GST number to verify the company details.",
							"ES": "We use the NIF, NIE or DNI number to verify the company details."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "VAT number",
								"AU": "ABN",
								"NZ": "GST number",
								"ES": "NIF/NIE/DNI"
							}
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "What type of business do you have?",
						"managed": "What type of business is this company?"
					},
					"subtitle": {
						"unmanaged": "We are required to ask some specific questions based on your business type.",
						"managed": "We are required to ask some specific questions based on the business type."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Legal entity type",
							"errors": {
								"is_one_of": "Please choose one of the listed business types"
							}
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Is your business a registered company?",
							"AU": "Does your business have an ACN?",
							"ES": "Is your company in the Registro Mercantil?"
						},
						"managed": {
							"default": "Is this business a registered company?",
							"AU": "Does this business have an ACN?",
							"ES": "Is your company in the Registro Mercantil?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "We need your company registration number to verify your business details.",
							"AT": "We need your company registration number to verify your business details.",
							"AU": "If you have an ACN please enter it, otherwise select no and proceed next.",
							"ES": "Answer Yes if you are an SL, SA, SCP, ...etc. Answer No if you are an autónomo, freelancer, ...etc",
							"GB": "We need your company organization number to verify your business details.",
							"GR": "We need your G.E.MI. number to verify the business details."
						},
						"managed": {
							"default": "We need the company registration number to verify the company business details.",
							"AT": "We need the company registration number to verify the company business details.",
							"AU": "If this company have an ACN please enter it, otherwise select no and proceed next.",
							"ES": "Answer Yes if you are an SL, SA, SCP, ...etc. Answer No if you are an autónomo, freelancer, ...etc",
							"GB": "We need the company organization number to verify the company business details.",
							"GR": "We need the company G.E.MI. number to verify the business details."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Please enter your registration number",
							"AT": "Please enter your registration number",
							"AU": "Please enter your your ACN",
							"ES": "Please enter your company NIF/NIE/DNI",
							"GB": "Please enter your organization number",
							"GR": "Please enter your G.E.MI. number (Γ.Ε.ΜΗ.)"
						},
						"managed": {
							"default": "Please enter the registration number",
							"AT": "Please enter the registration number",
							"AU": "Please enter the ACN",
							"ES": "Please enter your company NIF/NIE/DNI",
							"GB": "Please enter the organization number",
							"GR": "Please enter the G.E.MI. number (Γ.Ε.ΜΗ.)"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registration number",
								"AT": "Registration number",
								"AU": "Australian Company Number (ACN)",
								"ES": "Company NIF/NIE/DNI",
								"GB": "Organization number",
								"GR": "G.E.MI. number (Γ.Ε.ΜΗ.)"
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"mid-selector": {
					"title": "Select a store",
					"subtitle": "This email is associated with multiple stores. Please select a store to continue.",
					"mid-selector": "Merchant ID / Store Name",
					"buttons": {
						"next": "Continue"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "Is your business a registered company?",
						"managed": "Is this business a registered company?"
					},
					"subtitle": {
						"unmanaged": {
							"default": "We need your company registration number to verify your business details.",
							"AT": "We need your company registration number to verify your business details."
						},
						"managed": {
							"default": "We need the company registration number to verify the company business details.",
							"AT": "We need the company registration number to verify the company business details."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Please enter your registration number",
							"AT": "Please enter your registration number"
						},
						"managed": {
							"default": "Please enter the registration number",
							"AT": "Please enter the registration number"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registration number",
								"AT": "Registration number"
							}
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Is your business registered for VAT?",
							"ES": "Does your company have a NIF/NIE/DNI?",
							"NZ": "Is your business registered for GST?"
						},
						"managed": {
							"default": "Is this business registered for VAT?",
							"ES": "Does your company have a NIF/NIE/DNI?",
							"NZ": "Is this business registered for GST?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "If you have a VAT number, we can more easily verify your company details.",
							"ES": "If your company has a NIF/NIE/DNI number, we can more easily verify your company details.",
							"NZ": "If you have a GST number, we can more easily verify your company details."
						},
						"managed": {
							"default": "We use the VAT number to verify the company details.",
							"ES": "If your company has a NIF/NIE/DNI number, we can more easily verify your company details.",
							"NZ": "We use the GST number to verify the company details."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Please enter your VAT number",
							"ES": "Please enter your company NIF/NIE/DNI",
							"NZ": "Please enter your GST number"
						},
						"managed": {
							"default": "Please enter the VAT number",
							"ES": "Please enter your company NIF/NIE/DNI",
							"NZ": "Please enter your GST number"
						}
					},
					"vat_id": {
						"label": {
							"default": "VAT number",
							"ES": "Company NIF/NIE/DNI",
							"NZ": "GST number"
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "Is your business registered for VAT?",
						"managed": "Is this business registered for VAT?"
					},
					"subtitle": {
						"unmanaged": "If you have a VAT number, we can more easily verify your company details.",
						"managed": "We use the VAT number to  verify the company details."
					},
					"form_title": {
						"unmanaged": "Please enter your VAT number",
						"managed": "Please enter the VAT number"
					},
					"vat_id": {
						"label": {
							"default": "VAT number",
							"NZ": "GST number"
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "What is your business address?",
						"managed": "What is the company’s business address?"
					},
					"subtitle": {
						"unmanaged": "We need to know where your business is located.",
						"managed": "We need to know where the business is located."
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					},
					"fields": {
						"partnership_name": {
							"label": "Partnership Name",
							"errors": {
								"general": "Please enter a Partnership name"
							}
						},
						"street": {
							"label": "Address",
							"errors": {
								"general": "Please enter a valid address"
							}
						},
						"postal_code": {
							"label": "Postal Code",
							"errors": {
								"general": "Please enter a valid postal code"
							}
						},
						"city": {
							"label": "City",
							"errors": {
								"general": "Please enter a valid city"
							}
						},
						"country": {
							"label": "Country",
							"errors": {
								"general": "Please enter a valid country"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "Who owns the company?",
						"GB": "Who manages the company?"
					},
					"subtitle": {
						"default": [
							{
								"text": "We are legally required by the EU anti money laundering directive ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") to collect this information."
							}
						],
						"AU": [
							{
								"text": "As a financial institution we are legally required to collect this information."
							}
						]
					},
					"infobox": "Please enter the personal information and residential address of all partners and principals that exercise control over your company’s management.",
					"buttons": {
						"add_person": "+ Add person",
						"next": "Next",
						"back": "Back"
					}
				},
				"payouts_summary": {
					"title": "Bank accounts",
					"default_bank_accounts": {
						"no_elements": "No default bank account available"
					},
					"additional_bank_accounts": {
						"no_elements": "You did not submit any additional bank accounts"
					}
				},
				"pre_assessment_company_details": {
					"title": "Please fill in more opportunity details.",
					"subtitle": "Please provide us with share of card volume and the company details for this merchant. Please also indicate if the company operates from another market than the country of registration as this is required for risk assessment.",
					"fields": {
						"volume_by_card": {
							"label": "Share of card volume from total volume (%)",
							"errors": {
								"invalid": "Card volume should be a number between 0 and 100",
								"invalid_hint": "Please add the share of the volume of card transactions from the total Klarna volume for this opportunity. Please enter 0% if your opportunity does not have any card payments"
							}
						},
						"average_order_value": {
							"label": "Average order value (in SEK)",
							"tooltip": "Should be a positive amount in SEK",
							"errors": {
								"invalid": "Should be a positive amount in SEK"
							}
						},
						"registration_country": {
							"label": "Registration country",
							"errors": {
								"required": "Registration country is required"
							}
						},
						"operating_country": {
							"label": "Operating country",
							"errors": {
								"required": "Operating country is required"
							}
						},
						"registration_number": {
							"label": {
								"default": "Registration number (required for registered companies)",
								"AU": "ACN (required for registered companies)",
								"ES": "Company NIF/NIE/DNI (required for registered companies)",
								"GR": "G.E.MI. number (Γ.Ε.ΜΗ.) (required for registered companies)",
								"NZ": "Business number (required for registered companies)",
								"US": "TIN/EIN (required for registered companies)"
							}
						},
						"vat_number": {
							"label": "ABN",
							"errors": {
								"required": "Please provide ACN or ABN",
								"invalid": "ABN should be 11 digits long"
							}
						},
						"registration_authority": {
							"label": "Registration authority",
							"errors": {
								"required": "Please select your registration authority"
							}
						},
						"company_name": {
							"label": "Legal entity name",
							"errors": {
								"required": "Legal entity name is required"
							}
						},
						"sales_contact": {
							"label": "Business Developer (BD) email",
							"errors": {
								"invalid": "Please enter a valid email"
							}
						},
						"store_url": {
							"label": "Store URL",
							"errors": {
								"required": "Store URL is required",
								"invalid": "Please enter a valid website url"
							}
						},
						"goods_category": {
							"label": "Main category of goods sold",
							"errors": {
								"invalid": "You need to select one of the options"
							}
						},
						"is_managed": {
							"label": "Managed post going live?"
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"pre_assessment_products": {
					"title": "Please list all products",
					"subtitle": "For the risk assessment all products per selling country are required",
					"select": {
						"label": "Search product"
					},
					"selected": {
						"label": "Selected products:"
					},
					"clear": "Clear all",
					"errors": {
						"invalid": "At least one product per country should be selected"
					},
					"channels": {
						"ONLINE": "Online",
						"IN_STORE": "In-store",
						"TELESALES": "Tele sales",
						"SELLER_APP": "Seller app"
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"wrong_prefill_data": {
					"title": "Invalid data provided",
					"subtitle": "Invalid or incompatible prefill information provided by SalesForce.",
					"details": "Details: ",
					"fields": {
						"goodsCategory": "Goods category",
						"paymentInterval": "Payment interval",
						"paymentDelay": "Payment delay",
						"registrationCountry": "Registration Country",
						"storeUrl": "Store URL",
						"mainSellingCountry": "Main selling country",
						"products": "Products",
						"products_item": "Product {index}",
						"products_item_yearlyAcquiredVolume": "Product {index} yearly aquired volume",
						"products_item_sellingCountry": "Product {index} selling country",
						"products_item_productName": "Product {index} name",
						"products_item_channels": "Product {index} channels",
						"products_item_channels_item": "Product {index} channel"
					},
					"error_types": {
						"fallback": "is invalid",
						"any": {
							"required": "is required and none was provided"
						}
					}
				},
				"selling_countries": {
					"title": "Please list all selling countries",
					"subtitle": "The complete list of countries is required for risk assessment",
					"select": {
						"label": "Search country"
					},
					"selected": {
						"label": "Selected countries:"
					},
					"fields": {
						"selling_countries": {
							"label": "Select country",
							"errors": {
								"invalid": "You must select at least one country"
							}
						}
					},
					"clear": "Clear all",
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"main_selling_country": {
					"title": "Which is the main Klarna market for the merchant?",
					"subtitle": "Please select the market with the highest expected Klarna volume",
					"errors": {
						"invalid": "You need to select a country"
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"fca_number": {
					"title": "Please enter the FCA number",
					"subtitle": "We are legally required to verify the credit broker license.",
					"fields": {
						"fca_number": {
							"label": "FCA number",
							"errors": {
								"general": "Enter a valid FCA number"
							}
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"sole_trader": {
					"title": "Who owns the company?",
					"subtitle": {
						"default": [
							{
								"text": "We are legally required by the EU anti money laundering directive ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") to collect this information."
							}
						]
					},
					"infobox": {
						"unmanaged": "Please enter your personal information and residential address.",
						"managed": "Please enter the owner's information and residential address."
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "The person making the application is the same as the sole trader",
							"error": "Sorry, but you can only proceed if you as the sole trader are doing this application."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Do you operate from a different address?",
								"managed": "Does this company operate from a different address?"
							},
							"subtitle": {
								"unmanaged": "Only choose Yes if you are operating your business from another address than your residential address.",
								"managed": "Only choose Yes if this company operates their business from another address than the sole trader residential address."
							}
						},
						"title": "Please provide the business address",
						"fields": {
							"street": {
								"label": "Address",
								"errors": {
									"general": "Please provide a valid address"
								}
							},
							"postal_code": {
								"label": "Postal Code",
								"errors": {
									"general": "Please provide a valid postal code"
								}
							},
							"city": {
								"label": "City",
								"errors": {
									"general": "Please provide a valid city"
								}
							},
							"country": {
								"label": "Country",
								"errors": {
									"general": "Please provide a valid country"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "Can you please confirm two more things?",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "You are the Sole Trader",
							"label": "The person making the application is the same as the sole trader"
						},
						"are_you_the_only_with_financial_control": {
							"title": "Only you have financial control",
							"label": "The owner is the only person that has financial control over your business's bank account(s)"
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					},
					"robot_message": "Sorry, but we need to confirm these two things"
				},
				"underwriting_info": {
					"title": "Please specify the volume and payment delay of the opportunity",
					"subtitle": "Please list the overall expected yearly Klarna volume for this opportunity for all markets and the payment delay. In case the payment delay differs per country use the one for the selected main selling country.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Total Market Yearly Volume (in SEK)",
							"errors": {
								"invalid": "Total Market Yearly Volume should be a positive amount in SEK",
								"too_long": "Total Market Yearly Volume cannot have more than 16 digits"
							}
						},
						"payment_delay": {
							"label": "Payment delay",
							"errors": {
								"general": "Please provide a payment delay value",
								"invalid": "Payment delay should be a number between {min} and {max}"
							}
						},
						"payment_interval": {
							"label": "Payment interval",
							"errors": {
								"invalid": "You need to select one of the options"
							}
						},
						"volume_by_card": {
							"label": "Share of checkout (%)",
							"errors": {
								"invalid": "Share of checkout should be a number between 0 and 100",
								"invalid_hint": "Please add the share of the volume of card transactions from the total Klarna volume for this opportunity. Please enter 0% if your opportunity does not have any card payments"
							}
						},
						"average_order_value": {
							"label": "Average order value (in SEK)"
						}
					},
					"buttons": {
						"back": "Back",
						"next": "Next"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "What are your store details?"
						},
						"managed": "What are the store details?"
					},
					"subtitle": {
						"unmanaged": {
							"US": "We’ll use the information to set up your business account.",
							"default": "We will use the provided details as your primary contact information and to have a look at your store."
						},
						"managed": "We will use the provided details as the primary contact information for consumers and to have a look at the store."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Brand name / DBA",
								"MX": "Brand name / DBA",
								"US": "Brand name / DBA",
								"default": "Store name"
							},
							"errors": {
								"required": "Store name is required",
								"required_us": "Brand name / DBA is required",
								"invalid": "Please enter a store name of minimum 2 characters",
								"invalid_us": "Please enter a brand name / DBA of minimum 2 characters",
								"invalid_characters": "The store name cannot contain the following characters: < >",
								"invalid_characters_us": "The brand name / DBA cannot contain the following characters: < >"
							}
						},
						"website": {
							"label": "Online store website",
							"errors": {
								"required": "Website is required",
								"invalid": "Please enter a valid website url"
							}
						},
						"goods_category": {
							"label": "Main category of goods sold",
							"errors": {
								"required": "Goods category is required"
							}
						},
						"email": {
							"label": "Customer support email",
							"errors": {
								"required": "Customer support email is required",
								"invalid": "Please enter a valid email"
							}
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Change products"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "What is your registered business address?",
						"managed": "What is the registered business address of the company?"
					},
					"subtitle": {
						"unmanaged": "We need to know at which address your business is registered.",
						"managed": "We need to know at which address the business is registered at."
					},
					"question": {
						"title": {
							"unmanaged": "Do you operate from a different address?",
							"managed": "Does this company operate from a different address?"
						},
						"subtitle": {
							"unmanaged": "Only choose Yes if you are operating your business from another address than the registered business address.",
							"managed": "Only choose Yes if this company operates their business from another address than the registered business address."
						}
					},
					"toggle": {
						"title": "Add the address of principal place of business"
					},
					"fields": {
						"company_name": {
							"label": "Legal name of the company",
							"errors": {
								"general": "Please provide a company name"
							}
						},
						"street": {
							"label": "Address",
							"errors": {
								"general": "Please provide an address"
							}
						},
						"postal_code": {
							"label": "Postal code",
							"errors": {
								"general": "Please provide a postal code"
							}
						},
						"city": {
							"label": "City",
							"errors": {
								"general": "Please provide a city"
							}
						},
						"country": {
							"label": "Country",
							"errors": {
								"general": "Please provide a country"
							}
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					},
					"messages": {
						"lookup": "Is this your company? Please have a look and confirm if correct."
					}
				},
				"uk_sole_trader": {
					"title": "Who owns this company?",
					"subtitle": {
						"unmanaged": "You’re about to enter a contract with Klarna. Therefore, we need to collect your personal information.",
						"managed": "We are required to collect and verify the owner’s personal information."
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Do you operate from a different address?",
								"managed": "Does this company operate from a different address?"
							},
							"subtitle": {
								"unmanaged": "Only choose Yes if you are operating your business from another address than your residential address.",
								"managed": "Only choose Yes if this company operates their business from another address than the sole trader residential address."
							}
						},
						"title": "Please provide the business address",
						"fields": {
							"street": {
								"label": "Address",
								"errors": {
									"general": "Please provide a valid address"
								}
							},
							"postal_code": {
								"label": "Postal Code",
								"errors": {
									"general": "Please provide a valid postal code"
								}
							},
							"city": {
								"label": "City",
								"errors": {
									"general": "Please provide a valid city"
								}
							},
							"country": {
								"label": "Country",
								"errors": {
									"general": "Please provide a valid country"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "Who owns the company?",
					"subtitle": {
						"default": "As a financial institution we are legally required to collect this information."
					},
					"infobox": {
						"unmanaged": "Please enter your personal information and residential address.",
						"managed": "Please enter the owner's information and residential address."
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Do you operate from a different address?",
								"managed": "Does this company operate from a different address?"
							},
							"subtitle": {
								"unmanaged": "Only choose Yes if you are operating your business from another address than your residential address.",
								"managed": "Only choose Yes if this company operates their business from another address than the sole trader residential address."
							}
						},
						"title": "Please provide the business address",
						"fields": {
							"street": {
								"label": "Address",
								"errors": {
									"general": "Please provide a valid address"
								}
							},
							"postal_code": {
								"label": "Postal Code",
								"errors": {
									"general": "Please provide a valid postal code"
								}
							},
							"city": {
								"label": "City",
								"errors": {
									"general": "Please provide a valid city"
								}
							},
							"country": {
								"label": "Country",
								"errors": {
									"general": "Please provide a valid country"
								}
							},
							"region": {
								"label": "State",
								"errors": {
									"general": "Please provide a State"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "Are there any people who own more than 25% of the company?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "As a financial institution we are legally required to collect this information."
							}
						],
						"default": [
							{
								"text": "We need to know the people that own more than 25% of shares or voting rights of the company or exercise similar control. We are legally required by the EU anti money laundering directive ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") to collect this information."
							}
						]
					},
					"infobox": {
						"default": "Please enter each individual’s personal information and residential address.",
						"AU": "Please enter each individual's personal information and residential address. These must be natural persons for companies with complex ownership structures."
					},
					"buttons": {
						"next": "Next",
						"back": "Back",
						"add_person": "+ Add person"
					},
					"messages": {
						"lookup": "Do these people own more than 25% of your company? Please have a look and confirm if correct."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "What’s your business address?",
						"managed": "What the registered business address of the company?"
					},
					"subtitle": {
						"unmanaged": "This is where your business is legally registered, and will appear on your Klarna customer invoices.",
						"managed": "We need to know at which address the business is registered at."
					},
					"question": {
						"title": {
							"unmanaged": "Do you operate from a different address?",
							"managed": "Does this company operate from a different address?"
						},
						"subtitle": {
							"unmanaged": "Only choose Yes, if you are operating your business from another address than the registered business address.",
							"managed": "Only choose Yes if this company operates their business from another address than the registered business address."
						}
					},
					"toggle": {
						"title": "Add the address of principal place of business"
					},
					"fields": {
						"company_name": {
							"label": "Registered company name",
							"errors": {
								"general": "Please provide a company name"
							}
						},
						"street": {
							"label": "Address",
							"errors": {
								"general": "Please provide an address"
							}
						},
						"postal_code": {
							"label": "Postal code",
							"errors": {
								"general": "Please provide a postal code"
							}
						},
						"city": {
							"label": "City",
							"errors": {
								"general": "Please provide a city"
							}
						},
						"country": {
							"label": "Country",
							"errors": {
								"general": "Please provide a country"
							}
						},
						"state_of_incorporation": {
							"label": "State of incorporation",
							"errors": {
								"general": "Please provide a state of incorporation"
							}
						},
						"state": {
							"label": "State",
							"errors": {
								"general": "Please provide a state"
							}
						},
						"region": {
							"label": "Region",
							"errors": {
								"puerto_rico": "Puerto Rico not allowed"
							}
						}
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"select_products": {
					"title": "Our services",
					"title_kco_hidden": "Payment methods that increase sales.",
					"subtitle": "Pick the services that interest you.",
					"subtitle_kco_hidden": "Unlock your customer's purchasing power. Offer more payment options so they can decide when and how to pay.",
					"platform_alert": null,
					"buttons": {
						"next": "Next"
					}
				},
				"signup_products": {
					"title_line_1": "Klarna products for your store.",
					"title_kco_hidden_line_1": "Payment methods that",
					"title_kco_hidden_line_2": "increase sales.",
					"subtitle": "Offering Klarna payment methods leads to an average increase of 30% in conversion, 41% in AOV, and 36% in purchase frequency.",
					"subtitle_kco_hidden": "Unlock your customer's purchasing power. Offer more payment options so they can decide when and how to pay.",
					"info_block": "Showing available products for",
					"special_offer": "Special offer: {percentageFee}% + {fixedFee} per transaction. Valid until {validUntil}.",
					"buttons": {
						"contact_sales": "Contact Sales",
						"next": "Create account",
						"back": "Back"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Back",
						"next": "Next"
					}
				},
				"business_concepts": {
					"title": "Please select the applicable business concepts.",
					"subtitle": "Please only select the ones that apply. These can be multiple.",
					"errors": {
						"select_at_least_one": "Please select at least one business concept."
					},
					"buttons": {
						"next": "Next",
						"back": "Back"
					}
				},
				"confirm_copy": {
					"title": "Confirm Copy",
					"disclaimer": "Any existing information in the current MID will be overwritten with data from ",
					"merchant_id": "{mid}",
					"buttons": {
						"skipCopy": "Don’t copy",
						"confirmCopy": "Copy data"
					}
				},
				"pre_assessment_summary": {
					"title": "Summary",
					"subtitle": "Please review the data carefully before you submit it for underwriting",
					"banner": {
						"mcc_deal": "This is an MCC deal, please follow the MCC / ECC escalation routine"
					},
					"selling_countries": {
						"title": "Please select the market with the highest expected volume.",
						"main_selling_country": "Main selling country"
					},
					"pre_assessment_products": {
						"title": "Products"
					},
					"company_details": {
						"title": "Company Details"
					},
					"fca_number": {
						"title": "FCA Number"
					},
					"high_exposure_questionnaires": {
						"title": "High Exposure Questionnaires"
					},
					"mia_questionnaires": {
						"title": "MIA Questionnaires"
					},
					"buttons": {
						"back": "Back",
						"edit": "Edit",
						"submit": "Submit"
					}
				},
				"pre_assessment_overview": {
					"title": "Pre-assessment overview",
					"subtitle_APPROVED": "Please find the approved conditions for this opportunity below.",
					"subtitle_REJECTED": "Please find the rejected conditions for this opportunity below.",
					"subtitle_UNRESOLVED": "You are able to change the submitted information in case you spot any mistakes. This does not trigger a new case.",
					"status": {
						"APPROVED": "The case was approved",
						"REJECTED": "The case was rejected",
						"UNRESOLVED": "Waiting for underwriting decision...",
						"UNRESOLVED_TIMED_OUT": "The case will go through manual underwriting. Please be aware that this can take multiple days.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "View case in Merchant Review GUI",
						"STARTED": "The case is submitted for review"
					},
					"buttons": {
						"change": "Change",
						"new_case": "New Case"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "Hello!"
					},
					"subtitle": {
						"default": [
							{
								"text": "Being a regulated company under supervision of the Swedish Financial Supervisory Authority, Klarna is required to prevent money laundering as set forth in EU directive EU 2015/849 (as amended or replaced). For you as a merchant, the directive means that Klarna will collect information about the persons controlling your company (beneficial owners) before you can start using Klarna's services. Existing merchants shall provide such information on a regular basis to ensure it is up to date. You can find more information in the EU directive "
							},
							{
								"text": "here",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "."
							}
						]
					},
					"buttons": {
						"next": "Next"
					}
				},
				"recollection_confirmation": {
					"title": "Confirmation",
					"subtitle": "Please review the data carefully before you submit it for underwriting",
					"stakeholder": "Stakeholder {index}",
					"buttons": {
						"back": "Back",
						"submit": "Submit"
					}
				},
				"recollection_overview": {
					"title": "Thank you!",
					"subtitle": "Here is an overview of the information you submitted.",
					"stakeholder": "Stakeholder {index}",
					"notice": "Your information has been successfully submitted."
				},
				"volume_separation": {
					"title_line_1": "What’s your online business size?",
					"subtitle": "Klarna is equipped with the best solutions to suit your business—no matter how big or small.",
					"selector_title": "Yearly revenue",
					"below": "Below {threshold}",
					"between": "Between {belowThreshold} and {aboveThreshold}",
					"over": "Over {threshold}",
					"buttons": {
						"back": "Back"
					}
				},
				"basic_info": {
					"title_line_1": "Get your business",
					"title_line_2": "started with Klarna.",
					"subtitle": "We need some basic information to get you to the right place.",
					"fields": {
						"email": {
							"label": "Business E-mail",
							"field_link": "Not a business?",
							"errors": {
								"required": "Email address is required",
								"invalid": "Please enter a valid email address"
							}
						},
						"email_confirmation": {
							"label": "Confirm business E-mail",
							"tooltip": "Your business email will be a main way of communication with Klarna. Make sure it is correct",
							"errors": {
								"required": "Confirmation email address is required",
								"invalid": "Please make sure you entered the same email twice"
							}
						},
						"website": {
							"label": "E-commerce URL",
							"errors": {
								"required": "E-commerce URL is required",
								"invalid": "Please enter a valid URL"
							}
						},
						"country": {
							"label": "Country of registration",
							"errors": {
								"general": "Please select one of the available countries"
							}
						}
					},
					"buttons": {
						"continue": "Continue"
					}
				},
				"contact_details": {
					"title_line_1": "Let's have a chat.",
					"subtitle": "Complete this form and we’ll reach out ASAP with solutions tailored to your business.",
					"fields": {
						"full_name": {
							"label": "Full name",
							"errors": {
								"required": "Full name is required"
							}
						},
						"phone": {
							"label": "Phone number",
							"tooltip": "You need to include the country code, e.g. +1 541 754 3010",
							"errors": {
								"required": "Phone number is required",
								"invalid": "Invalid phone number"
							}
						},
						"tell_us_more": {
							"label": "Tell us a bit more about your business (optional)"
						}
					},
					"buttons": {
						"back": "Back",
						"submit": "Submit contact details"
					}
				},
				"contact_received": {
					"title": "Talk to you soon!",
					"message_1": "Our sales team will get in touch with you ASAP.",
					"message_2": "Our team will be in touch ASAP. We’ve also sent a confirmation of the information you submitted to "
				},
				"we_are_sorry": {
					"title": "We’re sorry. We were unable to accept your application at this point.",
					"message_1_unsupported_country": "Klarna currently does not support your selected country:",
					"message_1_sensitive_goods": "Klarna does not support the category of goods selected:",
					"message_1_platform": "Klarna does not support your selected e-commerce platform:",
					"message_2": "We’re always looking to create new partnerships so we’ll reach out as soon as we can continue with your application in the future.",
					"platform_alert": {
						"jtl4": [
							{
								"text": "You can still use the"
							},
							{
								"text": "plugin",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "from our partner Mollie."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "What platform are you on?",
					"subtitle": "Choose your e-commerce platform and we’ll get your business integrated in no time.",
					"custom": "Own built integration",
					"other_platform": "Other integration solutions",
					"platform_search": {
						"label": "E-commerce platform",
						"no_match": "No matches found for \"{input}\""
					},
					"buttons": {
						"back": "Back"
					}
				},
				"partner": {
					"title_line_1": "Which payment service partner would you like to onboard with?",
					"subtitle": "Choose the payment service partner that best suites your needs."
				},
				"account_creation_loading": {
					"title": "Creating your account...",
					"message": "Setting up your business ID..."
				},
				"application_checking": {
					"title": "Checking your application...",
					"message": "Analyzing store data"
				},
				"application_review": {
					"title": "We're reviewing your application.",
					"title_approved": "Your application was approved!",
					"message": "This is a manual process, so the handling times may vary, but we'll get it done as fast as possible.",
					"email_info_1": "We’ve sent you an email with the subject line “{subject}”.",
					"email_info_2": "Follow the steps there to log in and track your application status.",
					"email_info_2_approved": "Follow the steps there to log in and integrate Klarna to your e-commerce store.",
					"email_subject": "Welcome to Klarna's Merchant Portal",
					"resend_email": "Resend email"
				},
				"user_already_exists": {
					"title": "Log in to Merchant Portal to continue.",
					"message_1": "This e-mail address is already associated with a Merchant Portal account. To make changes to your existing account, please log in",
					"log_in": "Log in to Merchant Portal",
					"forgot_password": "Forgot your password?"
				},
				"otherPlatform": {
					"info": "We already have integration for {platform}",
					"link": "Start integration here",
					"title": "Smoooth, you can integrate directly!",
					"info2": "Good news! You can integrate Klarna to your e-commerce directly from <strong>{platform}</strong>.",
					"link2": "Go to {platform} + Klarna Integration"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Please reach out directly to our sales team",
							"SE": "Please reach out directly to our sales team on"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "Do you offer any of the following products or services?",
					"subtitle_2": "Klarna might define some items as restricted based on market, laws, sales volume, risk appetite, and other limitations that can be allowed and shall not be processed without Klarna's approval.",
					"titleV2": "Choose which of the below apply to your business.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Age restricted products",
							"description_2": "Tobacco, e-cigarettes, vape, cannabis products, alcohol, adult content"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Travel, tours and events",
							"description_2": "Transport, events, ticketing platform, hotels or accommodation, rentals, tour agencies"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Licensed weapons",
							"description_2": "Ammunition, fighting knives, hunting gear, batons, pepper spray"
						},
						"MARKETPLACE": {
							"title_2": "Peer to peer marketplace",
							"description_2": "Services that allow third parties to resell their goods or offer services via their online platform"
						},
						"PHARMACEUTICALS": {
							"title_2": "Pharma and medical services",
							"description_2": "Distribution of prescription pharmaceuticals, medical procedures including aesthetics & tattoos"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Memberships, subscriptions and services",
							"description_2": "Subscription on physical goods, digital content, streaming services, dating sites, etc"
						},
						"NONE": {
							"title_2": "I offer a different type of product/service"
						}
					},
					"link": "More about restricted items",
					"buttons": {
						"next": "Next",
						"continue": "Continue"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Enter your postal code to automatically fill other parts of your address",
						"US": "Enter your ZIP code to automatically fill other parts of your address"
					},
					"label": {
						"default": "Postal code",
						"US": "ZIP code"
					},
					"error": {
						"default": "Please enter a valid postal code",
						"US": "Please enter a valid ZIP code"
					}
				},
				"city": {
					"label": "City",
					"error": "Please enter a city"
				},
				"street": {
					"label": "Address",
					"error": "Please enter an address",
					"tooltip": "Start typing to see more street suggestions",
					"no_suggestion_found": "No matches for {input}"
				},
				"country": {
					"label": "Country",
					"error": "Please select a country"
				},
				"region": {
					"label": "State/region (optional)"
				},
				"state": {
					"label": "State",
					"error": "Please enter a state"
				}
			},
			"platforms": {
				"custom": "API integration",
				"other": "I can't find my platform"
			},
			"buttons": {
				"back": "Back"
			},
			"products": {
				"not_available": "Not available on {reason}",
				"not_available_country": "Not available in your country",
				"not_available_platform": "Not available on {platform}",
				"why_product": "Why Klarna {name}",
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Replace your store's checkout with Klarna complete checkout services."
					},
					"description_expanded": {
						"default": "Replace your store's checkout with Klarna complete checkout services."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Pay now"
							},
							"description": {
								"default": "Offer instant payments by card or bank transfer."
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "Pay in 30 days"
							},
							"description": {
								"default": "Offer 30 days to pay. No interest."
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Financing"
							},
							"description": {
								"default": "Offer to pay over 6-36 months.",
								"DE": "Offer to pay over 6-24 months",
								"AT": "Offer to pay over 6-24 months."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "Instalments"
							},
							"description": {
								"default": "Offer 3 interest-free installments.",
								"GB": "Offer 3 interest-free instalments."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "Installments",
								"AU": "Pay in 4"
							},
							"description": {
								"default": "Offer 4 interest-free installments.",
								"GB": "Offer 4 interest-free instalments."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Other payment options"
							},
							"description": {
								"default": "Credit cards, debit cards and more"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "On-site messaging"
							}
						},
						"billing": {
							"name": {
								"default": "Automatic Identification and billing"
							}
						},
						"shipping": {
							"name": {
								"default": "Personalized shipping options"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Post-purchase support"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Payment Method"
					},
					"description": {
						"default": "Add Klarna payment methods to your existing checkout"
					},
					"description_expanded": {
						"default": "Offering Klarna payment methods leads to an average increase of 30% in conversion, 41% in AOV and 36% in purchase frequency."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Pay now"
							},
							"description": {
								"default": "Offer instant payments by card or bank transfer."
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "Pay in 30 days"
							},
							"description": {
								"default": "Customers pay 30 days after purchase, with no interest."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Financing"
							},
							"description": {
								"default": "Customers can pay in 6-36 months.",
								"DE": "Customers can pay in 6-24 months",
								"AT": "Customers can pay in 6-24 months."
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "Instalments"
							},
							"description": {
								"default": "Offer 3 interest-free installments.",
								"GB": "Offer 3 interest-free instalments."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "4 Payments",
								"CA": "4 Payments",
								"AU": "Pay in 4"
							},
							"description": {
								"default": "Offer 4 interest-free installments.",
								"GB": "Offer 4 interest-free instalments.",
								"US": "Orders from $35 to $1000 can be split into 4 interest-free payments, due every 2 weeks.",
								"CA": "Orders from $35 to $1000 can be split into 4 interest-free payments, due every 2 weeks."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Pay by Card"
							},
							"description": {
								"default": "Offer instant payments by card or bank transfer."
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "How do you plan to do your sales?",
					"options": {
						"IN_STORE": "Physical store",
						"TELESALES": "Remote sales"
					},
					"description": {
						"IN_STORE": "Sales are primarily done in person and the customer gets the items right away.",
						"TELESALES": "Sales are primarily done over the phone from inbound customer calls. The customer doesn't get the items right away."
					}
				},
				"country": {
					"label": "Country"
				},
				"organization_category": {
					"label": "Legal entity Type",
					"options": {
						"SOLE_TRADER": "Sole trader",
						"PARTNERSHIP": "Partnership",
						"UNDEFINED": "UNDEFINED",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "C corporation",
						"S_CORP": "S corporation",
						"TRUST_ESTATE": "Trust/estate",
						"INDIVIDUAL": "Individual",
						"SOLE_PROPRIETORSHIP": "Sole proprietorship",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Single member LLC",
						"LIMITED_LIABILITY_COMPANY": "Limited liability company",
						"PUBLIC_LISTED_COMPANY": "Public listed company",
						"PRIVATE_COMPANY": "PRIVATE_COMPANY"
					}
				},
				"store_category": {
					"label": "Main category of goods sold",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Clothing & Shoes - Adult shoes and clothing",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Automotive Products - Automotive parts and accessories",
						"BAGS_AND_WALLETS": "Jewelry & Accessories - Bags and wallets",
						"BODY_AND_HAIR_CARE": "Health & Beauty - Body and hair care",
						"BOOK_AND_MAGAZINES": "Entertainment - Book and magazines",
						"CANDY": "Food & Beverage - Candy",
						"CAR_ELECTRONICS": "Electronics - Car electronics",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Children Products - Children clothes and nurturing products",
						"CHILDREN_TOYS": "Children Products - Children toys",
						"CLEANING_AND_SANITARY": "Home & Garden - Cleaning and sanitary",
						"COLLECTIBLES": "Leisure, Sport & Hobby - Collectibles",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Leisure, Sport & Hobby - Concept stores and miscellaneous",
						"COSMETICS": "Health & Beauty - Cosmetics",
						"COSTUMES_AND_PARTY_SUPPLIES": "Leisure, Sport & Hobby - Costumes and party supplies",
						"DATING_SERVICES": "Intangible products - Dating services",
						"DECORATION_AND_ART": "Home & Garden - Decoration and art",
						"DIETARY_SUPPLEMENTS": "Health & Beauty - Dietary supplements",
						"DIGITAL_SERVICES": "Intangible products - Digital services",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Children Products - Diversified children products",
						"DIVERSIFIED_ELECTRONICS": "Electronics - Diversified electronics",
						"DIVERSIFIED_ENTERTAINMENT": "Entertainment - Diversified entertainment",
						"DIVERSIFIED_EROTIC_MATERIAL": "Erotic Materials - Diversified erotic material",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Health & Beauty - Diversified health and beauty products",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Home & Garden - Diversified home and garden products",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Jewelry & Accessories - Diversified jewelry and accessories",
						"EDUCATION": "Intangible products - Education",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Electronics - Electronic equipment and related accessories",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Erotic Materials - Erotic clothing and accessories",
						"EVENT_TICKETS": "Intangible products - Event tickets",
						"FOOD_AND_BEVERAGE": "Food & Beverage - Food and beverage",
						"FRAGRANCES": "Health & Beauty - Fragrances",
						"FURNITURE": "Home & Garden - Furniture",
						"GENERAL_SHOES_AND_CLOTHING": "Clothing & Shoes - General shoes and clothing",
						"HOBBY_ARTICLES": "Leisure, Sport & Hobby - Hobby articles",
						"HOUSEHOLD_ELECTRONICS": "Electronics - Household electronics",
						"JEWELRY_AND_WATCHES": "Jewelry & Accessories - Jewelry and watches",
						"KITCHENWARE": "Home & Garden - Kitchenware",
						"MARKETPLACES": "Intangible products - Marketplaces",
						"MUSIC_AND_MOVIES": "Entertainment - Music and movies",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Leisure, Sport & Hobby - Musical instruments and equipment",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Jewelry & Accessories - Non prescription sunglasses and lenses",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Electronics - Office machines and related accessories",
						"OTHER_SERVICES": "Intangible products - Other services",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Health & Beauty - Personal care and body improvement",
						"PET_SUPPLIES": "Home & Garden - Pet supplies",
						"PHARMACEUTICAL_PRODUCTS": "Health & Beauty - Pharmaceutical products",
						"PLANTS_AND_FLOWERS": "Home & Garden - Plants and flowers",
						"PRESCRIPTION_OPTICS": "Health & Beauty - Prescription optics",
						"PRINTS_AND_PHOTOS": "Leisure, Sport & Hobby - Prints and photos",
						"SAFETY_PRODUCTS": "Home & Garden - Safety products",
						"SEX_TOYS": "Erotic Materials - Sex toys",
						"SPORTS_GEAR_AND_OUTDOOR": "Leisure, Sport & Hobby - Sports gear and outdoor",
						"TOBACCO": "Food & Beverage - Tobacco",
						"TOOLS_AND_HOME_IMPROVEMENT": "Home & Garden - Tools and home improvement",
						"TRAVEL_SERVICES": "Intangible products - Travel services",
						"UNDERWEAR": "Clothing & Shoes - Underwear",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Entertainment - Video games and related accessories",
						"WHEELS_AND_TIRES": "Automotive Products - Wheels and tires",
						"WINE_BEER_AND_LIQUOR": "Food & Beverage - Wine beer and liquor",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Clothing & Shoes - Youthful shoes and clothing"
					}
				},
				"currency": {
					"label": "Currency"
				},
				"account_type": {
					"label": "Bank account type",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Local Sweden",
						"LOCAL_US": "Local USA",
						"LOCAL_GENERIC": "Local Norway/Denmark",
						"SPECIAL": "Special",
						"BANKGIRO": "Local Sweden Bankgiro",
						"PLUSGIRO": "Local Sweden Plusgiro"
					}
				},
				"person_role": {
					"label": "Role",
					"options": {
						"LEGAL_REPRESENTATIVE": "Legal Representative",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Alternative Beneficial Owner",
						"ULTIMATE_BENEFICIAL_OWNER": "Ultimate Beneficial Owner",
						"OWNER": "Owner"
					}
				},
				"business_size": {
					"label": "Business size",
					"options": {
						"LARGE": "large",
						"MEDIUM": "medium",
						"small": "small"
					}
				},
				"sensitive_good_category": {
					"label": "Do you offer any of the following products or services at your physical store?",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Age restricted products",
						"LICENSED_WEAPONS": "Licensed weapons",
						"PHARMA_AND_MEDICAL_SERVICES": "Pharma and medical services",
						"TRAVEL_TOURS_EVENTS": "Travel, tours and events",
						"PEER_TO_PEER_MARKETPLACE": "Peer to peer marketplace",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Memberships, subscriptions and services",
						"NONE": "I offer a different type of product/service"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Tobacco, e-cigarettes, vape, cannabis products, alcohol, adult content",
						"LICENSED_WEAPONS": "Ammunition, fighting knives, hunting gear, batons, pepper spray",
						"PHARMA_AND_MEDICAL_SERVICES": "Distribution of prescription pharmaceuticals, medical procedures including aesthetics & tattoos",
						"TRAVEL_TOURS_EVENTS": "Transport, events, ticketing platform, hotels or accommodation, rentals, tour agencies",
						"PEER_TO_PEER_MARKETPLACE": "Services that allow third parties to resell their goods or offer services via their online platform",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Subscription on physical goods, digital content, streaming services, dating sites, etc",
						"NONE": "I offer a different type of product/service"
					},
					"error_message": "We're sorry. We are unable to continue with your application as currently we don't support the type of product or services you have selected."
				}
			},
			"common": {
				"country": {
					"label": "Country"
				},
				"address": {
					"city": {
						"label": "City"
					},
					"postal_code": {
						"label": "Postal code"
					},
					"region": {
						"label": "State/region"
					},
					"street_address": {
						"label": "Physical store address"
					},
					"street_address2": {
						"label": "Address line 2"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Company name"
					},
					"registration_authority": {
						"label": "Registration authority"
					},
					"registration_id": {
						"label": "Registration number"
					},
					"subject_to_vat": {
						"label": "Is your business registered for VAT?"
					},
					"vat_id": {
						"label": "VAT number"
					},
					"persons": {
						"date_of_birth": {
							"label": "Date of birth"
						},
						"first_name": {
							"label": "First name"
						},
						"last_name": {
							"label": "Last name"
						},
						"person_identity_document": {
							"label": "Identity document"
						},
						"person_proof_of_address": {
							"label": "Proof of address"
						},
						"personal_identifier": {
							"label": "Personal ID"
						}
					},
					"should_auto_capture_orders": {
						"label": "Would you like to automatically capture orders?",
						"tooltip": "Orders should be captured when handed over in-store or when shipped from a warehouse. By selecting auto-capture, the order will be automatically captured when the consumer confirms the purchase."
					}
				},
				"contract_entity": {
					"label": "Contractual entity"
				},
				"contract_onboarding_type": {
					"label": "Type of business partner onboarding"
				},
				"underwriting_inquiry_email": {
					"label": "Underwriting email"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Account holder name"
					},
					"account_number": {
						"label": "Account number"
					},
					"bic": {
						"label": "BIC code"
					},
					"iban": {
						"label": "Account number (IBAN)"
					},
					"is_default": {
						"label": "Use this account for unspecified currencies"
					},
					"routing_number": {
						"label": "Routing number"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "Contact email"
					},
					"name": {
						"label": "Store name"
					},
					"support_email": {
						"label": "Customer support email"
					},
					"support_phone": {
						"label": "Support phone number"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Traditional sale of goods",
							"VOUCHER": "Voucher",
							"MEMBERSHIP": "Membership",
							"SUBSCRIPTION": "Subscription",
							"PHARMACIES": "Pharmacies",
							"US_PHARMACIES": "US Pharmacies",
							"MEDICAL_SERVICES": "Medical Services",
							"MARKETPLACES": "Marketplaces",
							"FIREARM_DEALERS": "Firearm Dealers",
							"AUCTIONS": "Auctions",
							"ALCOHOL": "Alcohol",
							"TOBACCO": "Tobacco",
							"HEMP_CBD_THC": "Hemp, CBD, or THC",
							"DONATIONS_CHARITY": "Donations and Charity",
							"TRAVEL": "Travel",
							"EVENTS": "Events",
							"COURSES": "Courses",
							"EDUCATIONAL_COURSES": "Educational Courses",
							"FOOD_DELIVERY": "Food delivery",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "Customised pre-order/Furniture",
							"DIGITAL_CONTENT": "Digital content",
							"GAMING_INDUSTRY": "Gaming industry (Gambling, Betting, Casinos,  Lottery)"
						}
					}
				},
				"terms_and_conditions": {
					"default": "Terms and Conditions",
					"UPSELL_WEBSTORE_TO_KPOS": "Terms for Klarna In-store"
				},
				"pricing_terms": {
					"default": "Pricing terms",
					"UPSELL_WEBSTORE_TO_KPOS": "Pricing for Klarna In-store"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Additional information",
				"bank_account": "What are your bank account details?",
				"business_size": "What is your expected annual volume through Klarna Point of Sale?",
				"in_store_get_started": "Get your business started with Klarna.",
				"in_store_legal_form": "What type of business do you have?",
				"in_store_registered_address": "What is your registered address?",
				"in_store_registration": "Is your business a registered company?",
				"in_store_stakeholder": "Who manages the company?",
				"in_store_stores": "What are your store details for Klarna Point of Sale?",
				"in_store_vat": "Is your business registered for VAT?",
				"product_channel": "How does your business plan to use Klarna Point of Sale?",
				"sensitive_goods": "What category of products will you be selling with Klarna Point of Sale.",
				"ads_manager_get_started": "Almost there.",
				"content_store_get_started": "Almost there."
			},
			"subtitle": {
				"additional_data": "We are reviewing your application and need some more information to proceed.",
				"bank_account": "Klarna transactions will be transferred to this bank account.",
				"business_size": "We need some basic information regarding your business to process your application.",
				"in_store_get_started": "We need some basic information to get you to the right place",
				"in_store_legal_form": "We are required to ask some specific questions based on your business type.",
				"in_store_registered_address": "This is where your business is legally registered, and will appear in your klarna customer invoices.",
				"in_store_registration": "We need your company registration registration number to verify your business details.",
				"in_store_stakeholder": "As financial institution, we are required to collect this information",
				"in_store_stores": "We'll use the information to set up your new Klarna Point of Sale account.",
				"in_store_vat": "If you have a VAT number, we can more easily verify your company details.",
				"product_channel": "Choose your primary sales channel. You will be able to use Klarna Point of Sale for both channels.",
				"sensitive_goods": "The self-service onboarding for Klarna Point of Sale does not allow you to sell items that are defined by Klarna as restricted.",
				"ads_manager_get_started": "Please provide a billing email that campaign invoices will be sent to. You must be an admin user to activate the account. Admin can then grant permissions to other users.",
				"content_store_get_started": "Before getting access to Content Manager, please read and accept our Terms and Conditions."
			},
			"summary": {
				"title": "Before submitting your application review your details"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "We are processing your application. This might take a moment.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Please hold...",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Please hold..."
					},
					"paragraphs": {
						"default": [
							{
								"text": "Your application is being processed and we're creating your new Merchant ID."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "We're getting everything ready for your Ads Manager account."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "We're getting everything ready for your Content Manager account."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "Congratulations! Your application has been approved.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "You're all set!",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "You're all set!"
					},
					"paragraphs": {
						"default": [
							{
								"text": "Now let’s integrate Klarna in your online store. Head to the Products tab in your merchant portal account to find your integration credentials and instructions on how to use them."
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Now lets set up your store so you can start to receive payments right away."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Head over to Ads Manager to start creating your first campaign."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Head over to Content Manager and publish your first deal today."
							}
						]
					},
					"second_title": {
						"default": "Visit Klarna docs for more information on how to integrate with Klarna",
						"UPSELL_WEBSTORE_TO_KPOS": "Need help setting up your store? We are here to help you",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Need help using the Ads Manager? Check out our FAQ or reach out to our business support, we will be happy to assist you.",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Need help using Content Manager? Check out our FAQ or reach out to our business support, we will be happy to assist you."
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "Our best practices guidelines can help ou get the most of your new partnership with us."
							},
							{
								"text": "Klarna Checkout",
								"link": "#"
							},
							{
								"text": "Klarna Payments",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Reach out to our business support, we will be happy to assist you."
							},
							{
								"text": "Contact support",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Visit the FAQ.",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Visit the FAQ.",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "Let's go.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Let's go",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Let's go",
						"UPSELL_WEBSTORE_TO_KPOS": "Start selling"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "Thank you! We’re reviewing your application.",
					"badge": "Aprox 5-7 days",
					"paragraphs": [
						{
							"text": "You will receive an email when the review is complete or if we need any additional information."
						}
					],
					"second_title": "In the meantime check your email",
					"second_paragraphs": [
						{
							"text": "We’ve sent you an e-mail with the subject link \"Welcome to Klarna’s Merchant Portal\". Follow the steps there to log in and activate your account."
						}
					]
				},
				"SUSPENDED": {
					"title": "Unfortunately your application wasn’t approved.",
					"paragraphs": [
						{
							"text": "After reviewing your business details, we cannot move forward with your application for <strong>{businessName}</strong>."
						},
						{
							"text": "These are some of the most common reasons:"
						},
						{
							"list": [
								{
									"text": "Your store does not comply with the ethical guidelines of Klarna."
								},
								{
									"text": "Your customer service is unreachable."
								},
								{
									"text": "Other administrative factors."
								}
							]
						},
						{
							"text": "Thank you for your interest in <strong>Klarna [In-store]</strong> we hope we can do business in the future."
						}
					],
					"second_title": "If you have further questions",
					"second_paragraphs": [
						{
							"text": "Regarding our decision or any other Klarna product please contact us, we will be happy to assist you."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "Who signs the contracts for your company?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Your business is about to conclude a contract with Klarna. We need to verify who is legally authorized to sign contracts."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "Are there any people who own more than 25% of the company?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "As a financial institution we are legally required to collect this information."
							}
						],
						"default": [
							{
								"text": "We need to know the people that own more than 25% of shares or voting rights of the company or exercise similar control. We are legally required by the EU anti money laundering directive ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") to collect this information."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Who manages the company?"
					},
					"subtitle": {
						"default": [
							{
								"text": "We are legally required by the EU anti-money laundering directive ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") to collect this information."
							}
						],
						"US": [
							{
								"text": "As a financial institution we are legally required to collect this information."
							}
						],
						"CA": [
							{
								"text": "As a financial institution we are legally required to collect this information."
							}
						],
						"AU": [
							{
								"text": "As a financial institution we are legally required to collect this information."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Are there any people who own more than 25% of the company?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "As a financial institution we are legally required to collect this information."
							}
						],
						"default": [
							{
								"text": "We need to know the people that own more than 25% of shares or voting rights of the company or exercise similar control. We are legally required by the EU anti money laundering directive ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") to collect this information."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Solutions",
					"title_2": "Payment methods",
					"note": "All prices are per transaction.",
					"per_transaction": "per transaction",
					"cross_border_notice": "Additional cross-border fees may apply",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "please see",
						"link_text": "price appendix"
					},
					"not_available_for_business": "Not available for your business",
					"not_available_for_country": "You can only sell to other markets",
					"not_compatible_with_platform": "Not available for your platform",
					"installed": "Installed"
				},
				"buttons": {
					"next": "Next"
				}
			}
		}
	}
};